<!--
*****************************************************************************
*File : Dashboard.vue
*Module : Dashboard Frontend
*Purpose : Display the dashboard page containing information such as (Yard Performance , Point Machine count,Pie charts etc.)
*Author : UI Team
*Copyright : Copyright 2022, Lab to Market Innovations Private Limited
*****************************************************************************
-->

<template>
  <v-container id="dashboard" fluid tag="section">
    <audio ref="audioRef" autoplay loop src="trailThrough.mp3" v-if="this.ackBtn == 1 || this.fwild_defects.wheel_status_left == 2 || this.fwild_defects.wheel_status_right == 2 ||
      this.fwild_defects.wheel_status_left == 3 || this.fwild_defects.wheel_status_right == 3">
    </audio>

    <v-layout justify-center>
      <v-snackbar v-if="this.ackBtn == 1 || this.fwild_defects.wheel_status_left == 2 || this.fwild_defects.wheel_status_right == 2 ||
        this.fwild_defects.wheel_status_left == 3 || this.fwild_defects.wheel_status_right == 3" v-model="alert"
        :vertical="vertical" :top="top" :bottom="bottom" color="" outlined class="font-weight-bold" timeout=-1>

        <span style="color:#FF8F00"
          v-if="this.fwild_defects.wheel_status_left == 2 || this.fwild_defects.wheel_status_right == 2"> <v-icon>
            mdi-alert </v-icon> FWILD Maintenance defect found</span>
        <span style="color:#D50000"
          v-else-if="this.fwild_defects.wheel_status_left == 3 || this.fwild_defects.wheel_status_right == 3"> <v-icon>
            mdi-alert-octagon-outline </v-icon> FWILD Critical defect found </span>
        <span v-else-if="this.ackBtn == 1"> MVIS Defect found</span>
        <template v-slot:action="{ attrs }" v-if="this.ackBtn == 1">
          <v-btn color="primary" text v-bind="attrs" @click="acknowledgeit();alert = false; ">
            Acknowledge

          </v-btn>
        </template>
      </v-snackbar>
    </v-layout>

    <v-toolbar-title class="text-right font-weight-regular body-2">{{ this.dateDisplay }}</v-toolbar-title>

    <template><div>
      <h1 style="color: #3f51b5;"><center><u>MANAGEMENT INFORMATION SYSTEM</u></center></h1>
    </div></template>
    <br/>

    <template>
  <div>
    <h3 style="color: #3f51b5;">Select Month and Year</h3>

    <v-row>
      <v-col>
        <v-select
          v-model="selectedMonth"
          :items="months"
          label="Month"
          large-chips
         
        ></v-select>
      </v-col>

      <v-col>
        <v-select
          v-model="selectedYear"
          :items="years"
          label="Year"
          large-chips
          
        ></v-select>
      </v-col>
          <v-flex md4 class="py-4 px-16">
            <v-card-title>
              <div v-if="!isFutureMonthAndYear">
                <v-btn color="indigo"  @click="loadData()">Load</v-btn>
              </div>
            </v-card-title>
          </v-flex>
        </v-row>
    </div>
    </template>
    <template>
     
        <!-- Your content here -->
        <v-btn icon fab dark color="white"  @click="reloadPage()" class="home-button">
          <v-icon size="30">mdi-home</v-icon>
        </v-btn>
     
    </template>
    <template>
  <div>
    <v-btn v-if="showToTop" fab bottom right class="button2" @click="scrollToTop" color="indigo">
      <v-icon size="32">mdi-arrow-up</v-icon>
    </v-btn>
    <v-btn v-if="showToBottom" fab bottom right class="button1" @click="scrollToBottom" color="indigo">
      <v-icon size="32">mdi-arrow-down</v-icon>
    </v-btn>
  </div>
</template>

                                      <!-- THE MAIN DASHBOARD TABLE -->
    <v-row>
      <template>
        <v-data-table
        dense
      :headers="header_given_info"
      :items="fb_month_list"         
      :items-per-page="-1" 
      class="full-width-table"
      hide-default-footer
          >
          <template  v-slot:[`item.month`]="{ item }">
      <v-text-field v-if="item.month != null" class="" v-text="item.month" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.total_trains_passed`]="{ item }">
      <v-text-field v-if="item.total_trains_passed != null" class="" v-text="item.total_trains_passed" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.total_alerts`]="{ item }">
      <v-text-field v-if="item.total_alerts != null" class="" v-text="item.total_alerts" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.feedbackavailable`]="{ item }">
      <v-text-field v-if="item.feedbackavailable != null" class="" v-text="item.feedbackavailable" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.alerts_per_train`]="{ item }">
      <v-text-field v-if="item.alerts_per_train != null" class="" v-text="item.alerts_per_train" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.true_alerts`]="{ item }">
      <v-text-field v-if="item.true_alerts != null" class="" v-text="item.true_alerts" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.false_alerts`]="{ item }">
      <v-text-field v-if="item.false_alerts != null" class="" v-text="item.false_alerts" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.ratio_true_false`]="{ item }">
      <v-text-field v-if="item.ratio_true_false != null" class="" v-text="item.ratio_true_false" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.mvis_up_time`]="{ item }">
      <v-text-field v-if="item.mvis_up_time != null" class="" v-text="item.mvis_up_time" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>



  </v-data-table>
  </template>
</v-row>

                <!--SUMMARY BUTTON-->
    <v-flex md4 class="py-12 px-28">
            <v-card-title>
              <div v-if="epochStart <= epochEnd">
                <v-btn class="custom-button" color="success"  @click="showTable = true; habdFn(defaultStartDate, defaultEndDate); showssummary = true">Summary Report</v-btn>
              </div>
            </v-card-title>
    </v-flex>

    <template  >
    <div v-if="showssummary" class="display-1 font-weight-light" absolute>
      <h6 class="defect_heading" style="color: #3f51b5; display: inline;">  SUMMARY REPORT</h6>
      <h6 style="display: inline;"> ({{this.defaultStartDate}} to {{this.defaultEndDate}})</h6>
    </div>
    </template>

     <v-row v-if="showTable">
      <v-col cols="6" sm="7" lg="7">
        <template>
        <v-data-table
          dense
          :headers="headersTotal"
          :items="totalObjArr"
          :items-per-page="1"
          item-key="name"
          style="width: 300px; min-width: 300px;"
          hide-default-footer          
        >
        </v-data-table>
        </template>
      </v-col>
      </v-row>

    <v-row v-if="showTable">
    <template>
      
      
    <v-data-table
      dense
      :headers="headers"
      :items="tableValues"
      :items-per-page="20"
      item-key="name"
      class="full-width-table"
      hide-default-footer          
    >
   
    <template v-slot:[`item.totalVerified`]="{ item }">          
        <div v-if='item.totalVerified != 0' class=" text-left" v-text="item.totalVerified" ></div>                          
        <div v-else class="text-left" v-text="0" ></div>                        
    </template>
  
    <template v-slot:[`item.totalno`]="{ item }">          
        <div v-if='item.totalno != 0' class="text-left" v-text="item.totalno" ></div>                          
        <div v-else class="text-left" v-text="0" ></div>                        
    </template>
    <template v-slot:[`item.feedbackavailable`]="{ item }">          
        <div v-if='item.feedbackavailable != 0' class="text-left" v-text="item.feedbackavailable" ></div>                          
        <div v-else class="text-left" v-text="0" ></div>                        
    </template>        
    <template v-slot:[`item.trueCount`]="{ item }"> 
        <div v-if='item.trueCount != 0' class=" custom-pointer text-left indigo--text text-decoration-underline " @click="trueCountDetails(item); " v-text="item.trueCount" ></div>                          
        <div v-else class="text-left" v-text="0" ></div>                  
    </template>
    <template v-slot:[`item.falsePositive`]="{ item }">
        <div v-if='item.falsePositive != 0' class=" custom-pointer text-left indigo--text text-decoration-underline " @click="falseCountDetails(item); " v-text="item.falsePositive"></div>                 
        <div v-else class="text-left" v-text="0" ></div>                   
    </template>
    <template v-slot:[`item.percentageFalse`]="{ item }">          
        <div v-if='item.percentageFalse != 0' class="text-left" v-text="item.percentageFalse" ></div>                          
        <div v-else class="text-left" v-text="0" ></div>                        
    </template>
  

  </v-data-table>
</template>
</v-row>

<!-- <v-row v-if="showTable">
 <v-col cols="12">
    <v-data-table
      dense
      :headers="headers"
      :items="tableValues"
      :items-per-page="20"
      item-key="name"
      hide-default-footer
    >
      
      <template v-slot:[`item.totalTrain`]="{ item }">
        <tr>
          <th>TOTALTRAINS</th>
          <th>{{ this.totaltrains }}</th> 
          
        </tr>
      </template>

      
      <template v-slot:[`item.totalVerified`]="{ item }">
        <div v-if='item.totalVerified != 0' class="text-left" v-text="item.totalVerified"></div>
        <div v-else class="text-left" v-text="0"></div>
      </template>

      <template v-slot:[`item.totalno`]="{ item }">          
        <div v-if='item.totalno != 0' class="text-left" v-text="item.totalno" ></div>                          
        <div v-else class="text-left" v-text="0" ></div>                        
    </template>
    <template v-slot:[`item.feedbackavailable`]="{ item }">          
        <div v-if='item.feedbackavailable != 0' class="text-left" v-text="item.feedbackavailable" ></div>                          
        <div v-else class="text-left" v-text="0" ></div>                        
    </template>        
    <template v-slot:[`item.trueCount`]="{ item }"> 
        <div v-if='item.trueCount != 0' class=" custom-pointer text-left indigo--text text-decoration-underline " @click="trueCountDetails(item); " v-text="item.trueCount" ></div>                          
        <div v-else class="text-left" v-text="0" ></div>                  
    </template>
    <template v-slot:[`item.falsePositive`]="{ item }">
        <div v-if='item.falsePositive != 0' class=" custom-pointer text-left indigo--text text-decoration-underline " @click="falseCountDetails(item); " v-text="item.falsePositive"></div>                 
        <div v-else class="text-left" v-text="0" ></div>                   
    </template>
    <template v-slot:[`item.percentageFalse`]="{ item }">          
        <div v-if='item.percentageFalse != 0' class="text-left" v-text="item.percentageFalse" ></div>                          
        <div v-else class="text-left" v-text="0" ></div>                        
    </template>
      

    </v-data-table>
 </v-col>
</v-row> -->

<br/>

<!--true Alerts and false Alerts-->
    <v-card
    v-show = show_mvis_summary
  >
    <base-material-card
    color="indigo"
    icon="mdi-alert"
    inline
    class="px-5 py-3"
    v-show = show_mvis_summary
    >
       <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
             TRUE Defects <span class="body-1"></span>
            </div>

            <v-btn absolute top right color="indigo" 
              @click="show_mvis_summary=false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>

    <v-layout>
        <v-container fluid>

    <v-data-table
      :headers="header_defective_wagon_info"
      :items="mvis_summary_arr"
      class="elevation-1"
      :items-per-page="-1" 
      hide-default-footer
    >

    <template  v-slot:[`item.train_id`]="{ item }">
      <v-text-field v-if="item.train_id != null" class="" v-text="item.train_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.tagged_wagon_id`]="{ item }">
      <v-text-field v-if="item.tagged_wagon_id != null" class="" v-text="item.tagged_wagon_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.tagged_bogie_id`]="{ item }">
      <v-text-field v-if="item.tagged_bogie_id != null" class="" v-text="item.tagged_bogie_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.side`]="{ item }">
      <v-text-field v-if="item.side != null" class="" v-text="item.side" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.defect_image`]="{ item }">
      <PopupImage
        :pathAddress = "(item.defect_image)"
      >
      </PopupImage>
    </template>

    <template  v-slot:[`item.defect_desc`]="{ item }">
      <v-text-field v-if="(item.defect_desc) == null && roleName == 'General'" v-text="item.defect_desc" />
      <v-text-field v-else-if="(item.defect_desc == '-') || (item.defect_desc == null)" class="font-weight-light text-center" v-text="item.defect_desc" />
      <p v-else-if="(item.defect_desc == '003')" class="font-weight-light title" v-text="code3" ></p>
      <p v-else-if="(item.defect_desc == '009')" class="font-weight-light title" v-text="code9" ></p>
      <p v-else-if="(item.defect_desc == '004')" class="font-weight-light title" v-text="code4" ></p>
      <p v-else-if="(item.defect_desc == '006')" class="font-weight-light title" v-text="code6" ></p>
      <p v-else-if="(item.defect_desc == '007')" class="font-weight-light title" v-text="code7" ></p>
      <p v-else-if="(item.defect_desc == '005')" class="font-weight-light title" v-text="code5" ></p>           
      <p v-else-if="(item.defect_desc == '008')" class="font-weight-light title" v-text="code8" ></p>
      <p v-else-if="(item.defect_desc == '001')" class="font-weight-light title" v-text="code1" ></p>
      <p v-else-if="(item.defect_desc == '002')" class="font-weight-light title" v-text="code2" ></p>          
    </template>    

    </v-data-table>
   
	</v-container>
	</v-layout>
	</base-material-card>
  </v-card>

  <v-card 
    v-show = show_mvis_false_summary
  >
    <base-material-card
    color="indigo"
    icon="mdi-alert"
    inline
    class="px-5 py-3"
    v-show = show_mvis_false_summary
    >
       <template v-slot:after-heading>
            <div class="display-1 font-weight-light">
             FALSE Defects <span class="body-1"></span>
            </div>

            <v-btn absolute top right color="indigo"
              @click="show_mvis_false_summary=false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>

    <v-layout>
        <v-container fluid>

    <v-data-table
      :headers="header_defective_wagon_info"
      :items="mvis_false_summary_arr"
      class="elevation-1"
      :items-per-page="-1" 
      hide-default-footer
    >

    <template  v-slot:[`item.train_id`]="{ item }">
      <v-text-field v-if="item.train_id != null" class="" v-text="item.train_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.tagged_wagon_id`]="{ item }">
      <v-text-field v-if="item.tagged_wagon_id != null" class="" v-text="item.tagged_wagon_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.tagged_bogie_id`]="{ item }">
      <v-text-field v-if="item.tagged_bogie_id != null" class="" v-text="item.tagged_bogie_id" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.side`]="{ item }">
      <v-text-field v-if="item.side != null" class="" v-text="item.side" />
      <v-text-field v-else class="font-weight-light text-center" v-text="0" />
    </template>

    <template  v-slot:[`item.defect_image`]="{ item }">
      <PopupImage
        :pathAddress = "(item.defect_image)"
      >
      </PopupImage>
    </template>

    <template  v-slot:[`item.defect_desc`]="{ item }">
      <v-text-field v-if="(item.defect_desc) == null && roleName == 'General'" v-text="item.defect_desc" />
      <v-text-field v-else-if="(item.defect_desc == '-') || (item.defect_desc == null)" class="font-weight-light text-center" v-text="item.defect_desc" />
      <p v-else-if="(item.defect_desc == '003')" class="font-weight-light title" v-text="code3" ></p>
      <p v-else-if="(item.defect_desc == '009')" class="font-weight-light title" v-text="code9" ></p>
      <p v-else-if="(item.defect_desc == '004')" class="font-weight-light title" v-text="code4" ></p>
      <p v-else-if="(item.defect_desc == '006')" class="font-weight-light title" v-text="code6" ></p>
      <p v-else-if="(item.defect_desc == '007')" class="font-weight-light title" v-text="code7" ></p>
      <p v-else-if="(item.defect_desc == '005')" class="font-weight-light title" v-text="code5" ></p>           
      <p v-else-if="(item.defect_desc == '008')" class="font-weight-light title" v-text="code8" ></p>
      <p v-else-if="(item.defect_desc == '001')" class="font-weight-light title" v-text="code1" ></p>
      <p v-else-if="(item.defect_desc == '002')" class="font-weight-light title" v-text="code2" ></p>          
    </template>    

    </v-data-table>
   
	</v-container>
	</v-layout>
	</base-material-card>
  </v-card>





  <!-- MISSED ALERT BUTTON 
  <v-flex md4 class="px-30">
            <v-card-title>
              <div v-if="epochStart <= epochEnd">
                <v-btn class="custom-button" color="orange"  >MISSED ALERTS</v-btn>
              </div>
            </v-card-title>
    </v-flex>-->


    <!-- <template>
      <v-dialog        
        hide-overlay
        v-model="dialogFN"
        max-width="600"
        :retain-focus="false"
        persistent
        class="elevation-0"
        >
        <template v-slot:activator="{ on, attrs }">
          <v-flex md4 class="py-12 px-28">
            <v-btn
            color="warning"
            class="subtitle-1 font-weight-bold ml-4 large-button"           
            dark
            v-bind="attrs"
            v-on="on"
            >
            <v-icon @click="dialogFN=true"></v-icon>MISSED ALERTS
            </v-btn>
          </v-flex>
           
        </template>
        <v-card>
            <v-card-title class="text-h5 text--primary font-weight-bold ">
              MISSED ALERT FEEDBACK
            </v-card-title> 
            
         
            <v-row>
              <v-col cols="6">
                <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="startdateFormatted"
                    transition="scale-transition"
                    offset-y
                    persistent
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="startdateFormatted"
                        label="Select Date"
                        hint="DD-MM-YYYY format"
                        persistent-hint
                        prepend-icon="mdi-calendar-today"
                        v-bind="attrs"
                        @blur="startdate = parseDate1(startdateFormatted)"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startdate"
                      :max = "maxDate"
                      scrollable
                    >
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="modal = false">Cancel</v-btn>
                    <v-btn color="primary" @click="$refs.dialog.save(startdateFormatted)">OK</v-btn>
                    </v-date-picker>
                </v-dialog> 
              </v-col>

              <v-col cols="6">
                <v-dialog
                  ref="dialogTime"
                  v-model="modalTime"
                  :return-value.sync="selectedTimeFormatted"
                  transition="scale-transition"
                  offset-y
                  persistent
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="selectedTimeFormatted"
                      label="Select Time"
                      persistent-hint
                      prepend-icon="mdi-clock-time-four-outline"
                      v-bind="attrs"
                      @blur="selectedTime = parseTime(selectedTimeFormatted)"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker v-model="selectedTime">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="modalTime = false">Cancel</v-btn>
                    <v-btn color="primary" @click="$refs.dialogTime.save(selectedTimeFormatted)">OK</v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-col>
            </v-row>

            <v-text-field v-model="formData.train_id" 
                            label="Enter Train ID"
                            prepend-icon="mdi-train"
                            :rules="[v => !!v || 'Train ID is required']"
                            ></v-text-field>
            <v-spacer></v-spacer> 
            <v-text-field v-model="formData.tagged_wagon_id" 
                            label="Enter Tagged Wagon ID"
                            prepend-icon="mdi-train"
                            :rules="[v => !!v || 'Tagged Wagon ID is required']"
                            ></v-text-field>
            <v-spacer></v-spacer>  

           
                <v-select
                  v-model="formData.def_type"
                  :items="headers_defect_type"
                  menu-props="auto"
                  label="Select Defect Type"
                  hide-details
                  prepend-icon="mdi-alert-outline"
                  return-object
                  :rules="[v => !!v || 'Defect Type is required']"
                ></v-select>
          


            <v-spacer></v-spacer>
           

        <v-spacer></v-spacer>
        <br/>  
        <v-file-input
          v-model="formData.photo"
          label="Choose a file..."
          outlined
          accept="image/*"
          placeholder="No file chosen"
          :rules="[v => !!v || 'Photo is required']"
        ></v-file-input> 

        
        <v-textarea
            label="Remarks"
            outlined
            v-model="formData.remarks"
            :rules="[v => !!v || 'Remarks are required']"
            >
        </v-textarea>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="green darken-1"
                @click="dialogFN = false"
            >
                Cancel
            </v-btn>
            <v-btn
                color="green darken-1"
                @click="submitForm()"
                :disabled="!validateForm()"
            >
                Submit
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </template> -->

<!--started here
    <v-row>
      <v-col cols="12" sm="6" lg="4">
        <v-card>
            <v-avatar color="info" size="85" tile class="elevation-5 ml-3 mt-n5 rounded">
              <v-icon class="mt-1" color="white">mdi-train</v-icon>
            </v-avatar>
          <v-card-text class="text--primary font-weight-light fontChange mt-n16 text-end ">Today</v-card-text>
          <v-card-text v-if="this.current_day_train_count"
            class="text--primary font-weight-light display-2 mt-n7 text-end">{{ this.current_day_train_count }}</v-card-text>
          <v-card-text v-else class="text--primary font-weight-light display-2 mt-n7 text-end">0</v-card-text>

          <div class="px-2 mt-1">
            <v-row class="text-center">
              <v-col>
                <span class="font-weight-light fontChange text-center text-body1 px-n16 text-gray">Last Week</span><br>
                <span v-if="this.current_week_train_count" class="font-weight-light headline text-center">{{
                  this.current_week_train_count }}</span>
                <span v-else class="font-weight-light headline text-center ">0</span>
              </v-col>

              <v-col>
                <span class="font-weight-light fontChange text-center mt-8 text-gray">Last Month</span><br>
                <span v-if="this.prev_month_train_count" class="font-weight-light headline text-center">{{
                  this.prev_month_train_count }}</span>
                <span v-else class="font-weight-light headline text-center ">0</span>
              </v-col>

              <v-col cols="5">
                <span class="font-weight-light fontChange text-center">Current Month</span><br>
                <span v-if="this.current_month_train_count" class="font-weight-light headline text-center">{{
                  this.current_month_train_count }}</span>
                <span v-else class="font-weight-light headline text-center">0</span>
              </v-col>
            </v-row>
          </div>
          <v-divider class="ma-3 mt-n1" />
          <v-flex class="font-weight-light headline text-center info--text">Number of Trains</v-flex>
        </v-card>

      </v-col>


      <v-col cols="12" sm="6" lg="4">

        <v-card>
          <v-avatar color="green" size="85" tile class="elevation-5 ml-3 mt-n5 rounded">
            <v-icon class="mt-1" color="white">mdi-train</v-icon>
          </v-avatar>
          <v-card-text class="text--primary font-weight-light fontChange mt-n16 text-end ">Today</v-card-text>
          <v-card-text v-if="this.current_day_wagon_count"
            class="text--primary font-weight-light display-2 mt-n7 text-end">{{ this.current_day_wagon_count }}</v-card-text>
          <v-card-text v-else class="text--primary font-weight-light display-2 mt-n7 text-end">0</v-card-text>

          <div class="px-2 mt-1">
            <v-row class="text-center">
              <v-col>
                <span class="font-weight-light fontChange text-center px-n16 text-gray">Last Week</span><br>
                <span v-if="this.prev_week_wagon_count" class="font-weight-light headline text-center">{{
                  this.prev_week_wagon_count }}</span>
                <span v-else class="font-weight-light headline text-center ">0</span>
              </v-col>

              <v-col>
                <span class="font-weight-light fontChange text-center px-n16 text-gray">Last Month</span><br>
                <span v-if="this.prev_month_wagon_count" class="font-weight-light headline text-center">{{
                  this.prev_month_wagon_count }}</span>
                <span v-else class="font-weight-light headline text-center ">0</span>
              </v-col>

              <v-col cols="5">
                <span class="font-weight-light fontChange text-center">Current Month</span><br>
                <span v-if="this.current_month_wagon_count" class="font-weight-light headline text-center">{{
                  this.current_month_wagon_count }}</span>
                <span v-else class="font-weight-light headline text-center">0</span>
              </v-col>
            </v-row>
          </div>
          <v-divider class="ma-3 mt-n1" />
          <v-flex class="font-weight-light headline text-center green--text">Number of Wagons</v-flex>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" lg="4">
        <v-card>
          <v-avatar color="red" size="85" tile class="elevation-5 ml-3 mt-n5 rounded">
            <v-icon class="mt-1" color="white">mdi-alert</v-icon>
          </v-avatar>
          <v-card-text class="text--primary font-weight-light fontChange mt-n16 text-end ">Today</v-card-text>
          <v-card-text v-if="this.current_day_defect_count"
            class="text--primary font-weight-light display-2 mt-n7 text-end">{{ this.current_day_defect_count }}</v-card-text>
          <v-card-text v-else class="text--primary font-weight-light display-2 mt-n7 text-end">0</v-card-text>

          <div class="px-2 mt-1">
            <v-row class="text-center">
              <v-col>
                <span class="font-weight-light fontChange text-center text-gray">Last Week</span><br>
                <span v-if="this.prev_week_defect_count" class="font-weight-light headline text-center">{{
                  this.prev_week_defect_count }}</span>
                <span v-else class="font-weight-light headline text-center ">0</span>
              </v-col>

              <v-col>
                <span class="font-weight-light fontChange text-center text-gray">Last Month</span><br>
                <span v-if="this.prev_month_defect_count" class="font-weight-light headline text-center">{{
                  this.prev_month_defect_count }}</span>
                <span v-else class="font-weight-light headline text-center ">0</span>
              </v-col>

              <v-col cols="5">
                <span class="font-weight-light fontChange text-center">Current Month</span><br>
                <span v-if="this.current_month_defect_count" class="font-weight-light headline text-center">{{
                  this.current_month_defect_count }}</span>
                <span v-else class="font-weight-light headline text-center">0</span>
              </v-col>
            </v-row>
          </div>
          <v-divider class="ma-3 mt-n1" />
          <v-flex class="font-weight-light headline text-center red--text">MVIS Defects</v-flex>
        </v-card>
      </v-col>

    </v-row>
ended here-->
<br/>

<template>
  <div v-if="showscharts" class="display-1 font-weight-light" absolute>
    <h6 class="defect_heading" style="display: inline; color: #3f51b5;">DEFECT-WISE GRAPH</h6>
    <h6 style="display: inline;">
      ({{ isCurrentMonth ? startDATE : defaultStartDate }} to {{ isCurrentMonth ? defaultEndDate : endDATE }})
    </h6>
  </div>
  <div v-else class="display-1 font-weight-light" absolute>
    <h6 class="defect_heading" style="display: inline; color: #3f51b5;">DEFECT-WISE GRAPH</h6>
    <h6 style="display: inline;">({{ defaultStartDate }} to {{ defaultEndDate }})</h6>
  </div>
</template>





<v-row class="charts-section">
 <v-col cols="4" sm="6" md="4" lg="4">
    <base-material-card id="coloured-line" color="info" icon="mdi-chart-bar" class="px-4 py-3">
      <template v-slot:after-heading>
        <div class="title mt-2 font-weight-medium">
          Hanging Part (Side View)
        </div>
      </template>
      <div id="chart" class="mt-5">
        <apexchart type="bar" :height="245" :options="barChartData.chartOptions" :series="barChartData.series"></apexchart>
      </div>
    </base-material-card>
 </v-col>

 <v-col cols="4" sm="6" md="4" lg="4">
    <base-material-card id="coloured-line" color="info" icon="mdi-chart-bar" class="px-4 py-3">
      <template v-slot:after-heading>
        <div class="title mt-2 font-weight-medium">
          Hanging Part (Undercarriage)
        </div>
      </template>
      <div id="chart" class="mt-5">
        <apexchart type="bar" :height="245" :options="barChartData2.chartOptions" :series="barChartData2.series"></apexchart>
      </div>
    </base-material-card>
 </v-col>

 <v-col cols="4" sm="6" md="4" lg="4">
    <base-material-card id="coloured-line" color="info" icon="mdi-chart-bar" class="px-4 py-3">
      <template v-slot:after-heading>
        <div class="title mt-2 font-weight-medium">
          Spring Assembly	
        </div>
      </template>
      <div id="chart" class="mt-5">
        <apexchart type="bar" :height="245" :options="barChartData3.chartOptions" :series="barChartData3.series"></apexchart>
      </div>
    </base-material-card>
 </v-col>
</v-row>


<v-row class="charts-section">

 <v-col cols="4" sm="6" md="4" lg="4">
    <base-material-card id="coloured-line" color="info" icon="mdi-chart-bar" class="px-4 py-3">
      <template v-slot:after-heading>
        <div class="title mt-2 font-weight-medium">
          Axle Box Cover 
        </div>
      </template>
      <div id="chart" class="mt-5">
        <apexchart type="bar" :height="245" :options="barChartData5.chartOptions" :series="barChartData5.series"></apexchart>
      </div>
    </base-material-card>
 </v-col>
 <v-col cols="4" sm="6" md="4" lg="4">
    <base-material-card id="coloured-line" color="info" icon="mdi-chart-bar" class="px-4 py-3">
      <template v-slot:after-heading>
        <div class="title mt-2 font-weight-medium">
          End Cap Screw(s)
        </div>
      </template>
      <div id="chart" class="mt-5">
        <apexchart type="bar" :height="245" :options="barChartData6.chartOptions" :series="barChartData6.series"></apexchart>
      </div>
    </base-material-card>
 </v-col>
 <v-col v-if="barChartData7.series.length > 0" cols="4" sm="6" md="4" lg="4">
    <base-material-card id="coloured-line" color="info" icon="mdi-chart-bar" class="px-4 py-3">
        <template v-slot:after-heading>
            <div class="title mt-2 font-weight-medium">
                Yoke Pin Support Plate Bolts
            </div>
        </template>
        <div id="chart" class="mt-5">
            <apexchart type="bar" :height="245" :options="barChartData7.chartOptions" :series="barChartData7.series"></apexchart>
        </div>
    </base-material-card>
</v-col>



</v-row>

<v-row class="charts-section">
  <v-col cols="4" sm="6" md="4" lg="4">
    <base-material-card id="coloured-line" color="info" icon="mdi-chart-bar" class="px-4 py-3">
      <template v-slot:after-heading>
        <div class="title mt-2 font-weight-medium">
          EM Pad 
        </div>
      </template>
      <div id="chart" class="mt-5">
        <apexchart type="bar" :height="245" :options="barChartData8.chartOptions" :series="barChartData8.series"></apexchart>
      </div>
    </base-material-card>
 </v-col>
 <v-col cols="4" sm="6" md="4" lg="4">
    <base-material-card id="coloured-line" color="info" icon="mdi-chart-bar" class="px-4 py-3">
      <template v-slot:after-heading>
        <div class="title mt-2 font-weight-medium">
          Wagon Door 
        </div>
      </template>
      <div id="chart" class="mt-5">
        <apexchart type="bar" :height="245" :options="barChartData9.chartOptions" :series="barChartData9.series"></apexchart>
      </div>
    </base-material-card>
 </v-col>
</v-row>
 
    
    <v-card v-show="false" class="mx-auto" v-for="(item, i) in this.current_day_whole_info" :key="i">

      <v-avatar color="teal" size="85" tile class="elevation-10 ml-3 mt-n5 rounded">
        <span class="white--text headline text-xl font-weight-bold">{{ i + 1 }}</span>
      </v-avatar>

      <v-btn color="primary" dark x-large absolute top right tile class="elevation-10 mt-n9 rounded">
        <v-icon v-if="item.exit_time != null" @click="sendToPlay(item.train_id)" size="50">mdi-chevron-right</v-icon>
      </v-btn>

      <v-list shaped class="mt-n16 ml-16">
        <v-row>
          <v-col cols="12" sm="6" lg="3">
            <v-subheader class="fontChange font-weight-regular text--primary ml-6"><v-icon
                color="info">mdi-train</v-icon>Train details</v-subheader>

            <v-subheader v-if="item.train_id != null" class="fontChange font-weight-light text--primary ml-6"><v-icon
                color="info">mdi-train</v-icon>Train ID: {{ (item.train_id) }}</v-subheader>
            <v-subheader v-if="item.dfis_train_id != null" class="fontChange font-weight-light text--primary ml-6"><v-icon
                color="info">mdi-train</v-icon>DFIS Train ID: {{ (item.dfis_train_id) }}</v-subheader>
            <v-subheader v-if="(item.dfis_train_id) == null"
              class="fontChange font-weight-light text--primary ml-6"><v-icon color="info">mdi-train</v-icon>DFIS Train
              ID:
              <v-dialog hide-overlay v-model="dialogDfis" max-width="300" :retain-focus="false" persistent
                class="elevation-0">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" fab small dark v-bind="attrs" v-on="on">
                    <v-icon @click="rowClick(item)">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="text-h5 text--primary">
                    DFIS Train ID
                  </v-card-title>
                  <v-spacer></v-spacer>

                  <v-text-field label="Enter DFIS Train ID" outlined v-model="dfis">
                  </v-text-field>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" @click="dialogDfis = false">
                      Cancel
                    </v-btn>
                    <v-btn color="green darken-1" @click="addDfisTrainId">
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-subheader>

            <v-subheader v-if="item.direction != null" class="fontChange font-weight-light text--primary ml-6"><v-icon
                color="info">mdi-arrow-decision</v-icon>Direction: {{ (item.direction) }}</v-subheader>
          </v-col>
          <v-col cols="12" sm="6" lg="3">
            <v-subheader v-if="item.entry_time != null"
              class="fontChange font-weight-light text--primary ml-6 mt-12"><v-icon
                color="info">mdi-arrow-bottom-left-thick</v-icon>Arrival Time: {{ convertTimestamp(item.entry_time)
                }}</v-subheader>
            <v-subheader v-if="item.exit_time != null" class="fontChange font-weight-light text--primary ml-6"><v-icon
                color="info">mdi-arrow-top-right-thick</v-icon>Departure Time: {{ convertTimestamp(item.exit_time)
                }}</v-subheader>
            <v-subheader v-if="item.train_speed != null" class="fontChange font-weight-light text--primary ml-6"><v-icon
                color="info">mdi-speedometer</v-icon>Speed: {{ (item.train_speed) }}</v-subheader>
          </v-col>

          <v-col cols="12" sm="6" lg="6">
            <v-subheader class="fontChange font-weight-regular text--primary ml-6"><v-icon
                color="orange">mdi-alert</v-icon>Defect details </v-subheader>
            <v-subheader class="fontChange font-weight-light text--primary ml-6"><v-icon
                color="orange">mdi-train</v-icon>Tagged Wagon ID: {{ (item.tagged_wagon_id) }}</v-subheader>
            <v-subheader class="fontChange font-weight-light text--primary ml-6"><v-icon
                color="orange">mdi-train</v-icon>Tagged Bogie ID: {{ (item.tagged_bogie_id) }}</v-subheader>
            <v-subheader class="fontChange font-weight-light text--primary ml-6"><v-icon
                color="orange">mdi-alert-circle</v-icon>Side: {{ (item.side) }}</v-subheader>

          </v-col>
        </v-row>

      </v-list>
    </v-card>
  </v-container>
</template>

<script>
import Vue from 'vue'
import VueRouter from 'vue-router'
import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'
import PopupImage from './../report/popupImage';
import globalConf from '../../../globalConf';


Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.use(VueRouter)


import Api from '@/views/service/api'
import ApiResponse from '../service/api-response'

export default {
  name: "DashboardDashboard",

  components: {
    PopupImage,
    apexchart: VueApexCharts,

  },

  watch: {
    '$store.state.barChartDates': {
      immediate: true,
      handler(newValue) {
        this.barChartData = this.plotBarChart(this.$store.state.trainCount, this.$store.state.defectCount, newValue);

      },
    },
    '$store.state.barChartDates2': {
      immediate: true,
      handler(newValue) {
        this.barChartData2 = this.plotBarChart(this.$store.state.trainCount2, this.$store.state.defectCount2, newValue);

      },
    },
    '$store.state.barChartDates3': {
      immediate: true,
      handler(newValue) {
        this.barChartData3 = this.plotBarChart(this.$store.state.trainCount3, this.$store.state.defectCount3, newValue);

      },
    },
    // '$store.state.barChartDates4': {
    //   immediate: true,
    //   handler(newValue) {
    //     this.barChartData4 = this.plotBarChart(this.$store.state.trainCount4, this.$store.state.defectCount4, newValue);

    //   },
    // },
    '$store.state.barChartDates5': {
      immediate: true,
      handler(newValue) {
        this.barChartData5 = this.plotBarChart(this.$store.state.trainCount5, this.$store.state.defectCount5, newValue);

      },
    },
    '$store.state.barChartDates6': {
      immediate: true,
      handler(newValue) {
        this.barChartData6 = this.plotBarChart(this.$store.state.trainCount6, this.$store.state.defectCount6, newValue);

      },
    },
    '$store.state.barChartDates7': {
      immediate: true,
      handler(newValue) {
        this.barChartData7 = this.plotBarChart(this.$store.state.trainCount7, this.$store.state.defectCount7, newValue);

      },
    },
    '$store.state.barChartDates8': {
      immediate: true,
      handler(newValue) {
        this.barChartData8 = this.plotBarChart(this.$store.state.trainCount8, this.$store.state.defectCount8, newValue);

      },
    },
    '$store.state.barChartDates9': {
      immediate: true,
      handler(newValue) {
        this.barChartData9 = this.plotBarChart(this.$store.state.trainCount9, this.$store.state.defectCount9, newValue);

      },
    },
    '$store.state.ackStatus': 
    // {
      // immediate: true,
      function (newValue, oldValue) {
        console.log('changed from : ', newValue, oldValue);
        if(newValue > oldValue) {
          this.ackBtn = 1;
          this.alert = true;
        } else {
          this.ackBtn = 0;
          this.alert = false;
        }
      },
    // },

    // '$store.state.seriesPie': {
    //   immediate: true,
    //   handler(newValue) {
    //     this.pieChartHABDData = this.plotPieHABDChart(this.$store.state.seriesPie, newValue);
    //   },
    // },
    '$store.state.seriesPie': {
      immediate: true,
      handler(newValue) {
        this.barDefectwiseData = this.plotDefectwiseBarChart(this.$store.state.seriesPie, this.$store.state.seriestruePer, newValue);
      },
    },
    // '$store.state.seriesPie': {
    //   immediate: true,
    //   handler(newValue) {
    //     this.barTotalTrueFalseData = this.plotTotalTFBarChart(this.$store.state.seriesTotalTrue, this.$store.state.seriesTotalFalse, newValue);
    //   },
    // },

    $route(to, from) {
      this.audio_pause = true;
    },
    startdate (val) {
      this.startdateFormatted = this.formatDate1(this.startdate)
      this.epochStart = this.epochConvert(this.startdate)
    },
    enddate (val) {
      this.enddateFormatted = this.formatDate1(this.enddate)
      this.epochEnd = this.epochConvert(this.enddate)
    },

  },

  mounted() {
    // Get the current date
    const currentDate = new Date();
    // Set the day to the first day of the current month
    currentDate.setDate(1);
    // Format the start date (first day of the current month)
    const startDate = currentDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    this.startDATE = `${startDate.split('/').join('-')}`;

    // Reset the current date to today
    currentDate.setDate(new Date().getDate());
    // Format the end date (current day)
    const endDate = currentDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    this.endDATE = `${endDate.split('/').join('-')}`;

    
    const currentDate2 = new Date();

    // Set end date to current date
    const endDate2 = currentDate2.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });

    // Set start date to two months before the current date
    const startDate2 = new Date(currentDate2);
    startDate2.setDate(1); // Set to the 1st day of the month
    startDate2.setMonth(startDate2.getMonth() - 2); // Set the month after setting the date

    // Format the dates
    const formattedStartDate = startDate2.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    const formattedEndDate = endDate2;

    this.defaultStartDate = formattedStartDate.split('/').join('-');
    this.defaultEndDate = formattedEndDate.split('/').join('-');

    console.log("DATESSS:",currentDate2,startDate2,endDate2) 

    // Assuming dashboardFn, populateYears, and habdFn are methods defined in your Vue component
    this.dashboardFn();
    this.populateYears();
    this.habdFn(this.defaultStartDate, this.defaultEndDate);
    window.addEventListener('scroll', this.handleScroll);
},

  created() {

    this.barChartData = this.plotBarChart(this.$store.state.trainCount, this.$store.state.defectCount, this.$store.state.barChartDates); 
    this.barChartData2 = this.plotBarChart(this.$store.state.trainCount2, this.$store.state.defectCount2, this.$store.state.barChartDates2);
    this.barChartData3 = this.plotBarChart(this.$store.state.trainCount3, this.$store.state.defectCount3, this.$store.state.barChartDates3); 
    // this.barChartData4 = this.plotBarChart(this.$store.state.trainCount4, this.$store.state.defectCount4, this.$store.state.barChartDates4); 
    this.barChartData5 = this.plotBarChart(this.$store.state.trainCount5, this.$store.state.defectCount5, this.$store.state.barChartDates5); 
    this.barChartData6 = this.plotBarChart(this.$store.state.trainCount6, this.$store.state.defectCount6, this.$store.state.barChartDates6); 
    this.barChartData7 = this.plotBarChart(this.$store.state.trainCount7, this.$store.state.defectCount7, this.$store.state.barChartDates7); 
    this.barChartData8 = this.plotBarChart(this.$store.state.trainCount8, this.$store.state.defectCount8, this.$store.state.barChartDates8); 
    this.barChartData9 = this.plotBarChart(this.$store.state.trainCount9, this.$store.state.defectCount9, this.$store.state.barChartDates9); 
    this.pieChartData = this.plotPieChart(this.$store.state.pieCntArr, this.$store.state.pointIds);
    this.pieChartHABDData = this.plotPieHABDChart(this.$store.state.seriesPie);
    this.barDefectwiseData = this.plotDefectwiseBarChart(this.$store.state.seriesPie, this.$store.state.seriestruePer, this.$store.state.barChartDates);
    // this.barTotalTrueFalseData = this.plotTotalTFBarChart(this.$store.state.seriesTotalTrue, this.$store.state.seriesTotalFalse, this.$store.state.barChartDates);

    setInterval(() => {
      this.dateDisplay = this.getDateDisplay();
    }, 1000);

    this.dashboardFn();
    this.timer = setInterval(this.dashboardFn, 300 * 1000);
    this.resTimer = setInterval(this.snackRes, 300 * 1000);
  },

  data() {
    return {
      monthNumber: new Date().getMonth(),
      totaltrains:0,
      showToTop: false,
      showToBottom: true,
      lastScrollPosition: 0,
      selectedMonth: null,
      selectedYear: null,
      months: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      years: [],
      showssummary : false,
      showscharts : false,
      formData:{
        train_id:'',
        remarks:'',
        def_type: { text: 'All', show: true, value: 'All', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" }, 
        photo:null,
        tagged_wagon_id:''
      },
      dialogFN:false,
      showTable: false,
      audioPath: 'trailThrough.mp3',
      ackBtn: 0,
      date2: this.getCurrentDateIST(),
      dateDisplay: this.getDateDisplay(),
      maxDate: this.disableFutureDates(new Date()),
      itemsPerPageOptions: -1, //-1 refers to All
      dateArr: [],
      dashboard: '',
      unloadedData: '',
      yesterday_torpedoes_unloaded: '',
      today_torpedoes_unloaded: '',
      week_torpedoes_unloaded: '',
      today_unloadEntryTS_Arr: [],
      today_unloadExitTS_Arr: [],
      today_trainEntryTS_Arr: [],
      prev_unloadEntryTS_Arr: [],
      prev_unloadExitTS_Arr: [],
      prev_trainEntryTS_Arr: [],
      next_unloadEntryTS_Arr: [],
      next_unloadExitTS_Arr: [],
      week_unloadEntryTS_Arr: [],
      week_unloadExitTS_Arr: [],
      week_trainEntryTS_Arr: [],
      week_linechartArr: [],
      week_dateArr: [],
      pointIdArr: [],
      cur_pointIndxCnt: [],
      prev_pointIndxCnt: [],
      week_pointIndxCnt: [],
      week_pointAutomateCnt: [],
      newJoinArray: [],
      query_today: '',
      today_avg_unload_time: 0,
      prev_avg_unload_time: 0,
      week_avg_unload_time: 0,
      today_avg_wait: '',
      prev_avg_wait: '',
      week_avg_wait: '',
      search: '',
      selection: 1,
      yards: [],
      day_perf: [],
      day_train_count: '',
      day_unloaded: '',
      objWeek_dateArr: {},
      objWeek_linecharArr: {},
      weekChart: {},
      weekPie: {},
      prevPoint_cntArr: [],
      curPoint_cntArr: [],
      weekPoint_cntArr: [],
      torpedo_long_wait: '',
      plotLine: '',
      sum_prev: 0,
      sum_cur: 0,
      sum_week: 0,
      arr_pieWeek: 0,
      barChartData: {},
      barChartData2: {},
      barChartData3: {},
      barChartData5: {},
      barChartData7: {},
      barChartData8: {},
      barChartData9: {},
      pieChartData: {},
      barDefectwiseData :{},
      barTotalTrueFalseData: {},
      pieChartHABDData: {},
      pointPieArr: [],
      todayPointCount: 0,
      yesterdayPointCount: 0,
      weekPointCount: 0,
      ps1_count: [],
      ps2_count: [],
      ps3_count: [],
      ps4_count: [],
      get_week_dates: [],
      user_ip: '',
      fb_month_list: [],
      def_1:[],
      def_2:[],
      def_3:[],
      def_4:[],
      def_5:[],
      def_6:[],
      def_7:[],
      def_8:[],
      def_9:[],
      current_day_whole_info: [],
      fb_not_given_result:[],
      current_day_train_info: [],
      current_day_train_info1: [],
      current_day_defect_info: [],
      dfis_train_id: '',
      selectedRow: [],
      isHidden: false,
      textFields: [],
      dfis: '',
      action: '',
      dialogRemarks: false,
      remarks: '',
      updateRemarks: '',
      dialogDfis: false,
      dialogAction: false,
      dashboardFullDay: [],
      day_info: [],
      current_day_train_count: 0,
      current_week_train_count: 0,
      prev_month_train_count: 0,
      current_month_train_count: 0,
      current_day_defect_count: 0,
      prev_month_defect_count: 0,
      prev_week_defect_count: 0,
      current_month_defect_count: 0,
      current_day_wagon_count: 0,
      prev_week_wagon_count: 0,
      prev_month_wagon_count: 0,
      current_month_wagon_count: 0,
      current_day_alarm_count: 0,
      prev_week_alarm_count: 0,
      prev_month_alarm_count: 0,
      current_month_alarm_count: 0,
      consol_traindetailed1: [],
      consol_traindetailed2: [],
      consol_traindetailed: [],
      trainDetailed: [],
      entry_train_detailed: [],
      consol_trainconsolidated1: [],
      consol_trainconsolidated2: [],
      current_day_count: 0,
      timer: "",
      resTimer: "",
      week_date_list: [],
      week_train_count_list: [],
      week_defect_count_list: [],
      week_date_list_2: [],
      week_train_count_list_2: [],
      week_defect_count_list_2: [],
      week_date_list_3: [],
      week_train_count_list_3: [],
      week_defect_count_list_3: [],
      // week_date_list_4: [],
      // week_train_count_list_4: [],
      // week_defect_count_list_4: [],
      week_date_list_5: [],
      week_train_count_list_5: [],
      week_defect_count_list_5: [],
      week_date_list_6: [],
      week_train_count_list_6: [],
      week_defect_count_list_6: [],
      week_date_list_7: [],
      week_train_count_list_7: [],
      week_defect_count_list_7: [],
      week_date_list_8: [],
      week_train_count_list_8: [],
      week_defect_count_list_8: [],
      week_date_list_9: [],
      week_train_count_list_9: [],
      week_defect_count_list_9: [],
      vertical: false,
      bottom: "",
      top: "",
      snackbarTimeout: 0,
      alert: true,
      fwild_defects: [],
      noTrueCount: "-",
      audio_pause: false,
      selectedTime:new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      selectedTimeFormatted:this.formatTime(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })),
      startdate: new Date().toISOString().substr(0, 10),
      startdateFormatted: this.formatDate1(new Date().toISOString().substr(0, 10)),
      enddate: new Date().toISOString().substr(0, 10),
      enddateFormatted: this.formatDate1(new Date().toISOString().substr(0, 10)),
      epochStart: this.epochConvert(new Date().toISOString().substr(0, 10)),
      epochEnd: this.epochConvert(new Date().toISOString().substr(0, 10)),
      startDate: '',
      endDate:'',
      startDATE:'',
      defaultStartDate:'',
      defaultEndDate:'',
      endDATE:'',
      CurrStartDate:new Date().toISOString().substr(0, 10),
      CurrEndDate:new Date().toISOString().substr(0, 10),
      modal: false,
      modal1: false,
      modalTime:false,
      tableValues: [],
      totalObjArr: [],
      habd_results_arr: [],
      remarks:'',
      new_fieldreport:'',
      def_fn_typ: { text: 'All', show: true, value: 'All', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" }, 
      roleName: this.$store.state.logUserAdmin,
      headers: [
      // { text: 'Total Trains', value: 'totalTrain', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Details', value: 'details', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Total Units (Verified)', value: 'totalVerified', class: "font-weight-medium title text-right indigo--text elevation-1 text-uppercase" },
        { text: 'Total (Alerts)', value: 'totalno', class: "font-weight-medium title text-right indigo--text elevation-1 text-uppercase" },
        { text: 'Feedback Given', value: 'feedbackavailable', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'True Alerts', value: 'trueCount', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'False Alerts', value: 'falsePositive', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Missed Alerts', value: 'missingAlerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'False Alerts (%)', value: 'percentageFalse', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],
      headersTotal: [
        { text: 'Total Trains', value: 'totalTrain', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Total Axle', value: 'totalAxle', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
    ],
      mvis_defect_code_num: {
        'Hanging Part (side view)': '003',
        'Hanging Part (Undercarriage)': '009',
        'Missing Spring(s)': '004',
        'Broken Spring(s)': '006',
        'Axle box cover': '007',
        'End cap screw(s)': '005',
        'Yoke pin support plate bolts': '008',  
        'EM Pad': '001',
        'Wagon Door': '002',              
      },
      show_mvis_summary: false,
      show_mvis_false_summary: false,
      downloadLoading: false,
      autoWidth: true,
      bookType: 'xlsx',
      exelArr :[],
      mvis_summary_arr: [],
      mvis_false_summary_arr: [],
      mvis_defectwise_arr: [],

      headers_defect_type: [
        // { text:s 'All', show: true, value: 'All', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Hanging part (side view)', show: true, value: '003', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Hanging part - Undercarriage', show: true, value: '009', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Missing spring(s)', show: true, value: '004', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Broken spring(s)', show: true, value: '006', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Missing axle box cover', show: true, value: '007', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Missing end cap screw(s)', show: true, value: '005', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },                
        { text: 'Missing yoke pin support plate bolts', show: true, value: '008', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Defective EM Pad', show: true, value: '001', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Open wagon door', show: true, value: '002', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },              
        
      ],
      header_defective_wagon_info: [
        { text: 'Train ID' , value: 'train_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Tagged Wagon ID' , value: 'tagged_wagon_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Wagon No.', value: 'tagged_bogie_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        //{ text: 'Wagon ID', value: 'wagon_id', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        //{ text: 'Wagon Type', value: 'wagon_type', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        //{ text: 'Side', value: 'side', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Defect Image', value: 'defect_image', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Defect Description', value: 'defect_desc', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Action Taken', value: 'action_taken', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],
      header_given_info: [
        { text: 'Month' , value: 'month', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Total Trains' , value: 'total_trains_passed', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Total (Alerts)' , value: 'total_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Feedback Given' , value: 'feedbackavailable', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'Alerts per Train', value: 'alerts_per_train', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },        
        { text: 'True Alerts', value: 'true_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'False Alerts', value: 'false_alerts', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        { text: 'False to Total Alerts(%)', value: 'ratio_true_false', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
        // { text: 'Server up time(%)', value: 'mvis_up_time', class: "font-weight-medium title text-center indigo--text elevation-1 text-uppercase" },
      ],
      code1: 'Defective EM Pad',
      code2: 'Open wagon door',
      code3: 'Hanging part (side view)',
      code4: 'Missing spring(s)',
      code5: 'Missing end cap screw(s)',
      code6: 'Broken spring(s)',
      code7: 'Missing axle box cover',
      code8: 'Missing yoke pin support plate bolts',
      code9: 'Hanging part - Undercarriage',
    }

    
  },

  computed: {
    isCurrentMonth() {
      const today = new Date();
      const currentMonth = today.getMonth() + 1; // JavaScript months are 0-indexed
      const startMonth = parseInt(this.startDATE.split('-')[1]);
      const endMonth = parseInt(this.endDATE.split('-')[1]);
      return currentMonth === startMonth || currentMonth === endMonth;
    },
    currentMonth() {
      return new Date().getMonth(); // 0-based month index
    },
    currentYear() {
      return new Date().getFullYear();
    },
    selectedMonthIndex() {
      return this.months.indexOf(this.selectedMonth);
    },
    isFutureMonthAndYear() {
      if (this.selectedYear > this.currentYear) {
        return true;
      }
      if (this.selectedYear === this.currentYear && this.selectedMonthIndex > this.currentMonth) {
        return true;
      }
      return false;
    },
  },
  methods: {

    handleScroll() {
      const currentScrollPosition = window.scrollY;
      this.showToTop = currentScrollPosition > 0;
      this.showToBottom = currentScrollPosition < this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    scrollToBottom() {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    },

     formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    },

    populateYears() {
      const currentYear = new Date().getFullYear();
      for (let year = currentYear - 1; year <= currentYear + 15; year++) {
        this.years.push(year);
      }
    },


    loadData() {
  const selectedMonth = this.selectedMonth;
  const selectedYear = this.selectedYear;

  if (selectedMonth !== null && selectedYear !== null) {
    // Map month names to numbers
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    const monthNumber = monthNames.indexOf(selectedMonth);

    // Check if the month name is valid
    if (monthNumber !== -1) {
      // Set the start date to the first day of the selected month and year
      const startDay = new Date(selectedYear, monthNumber, 1);

      // Calculate the last day of the selected month
      const lastDay = new Date(selectedYear, monthNumber + 1, 0);

      // Set the end date to the last day of the selected month and year
      this.endDATE = this.formatDate(lastDay);
      this.startDATE = this.formatDate(startDay);
      const sd = this.startDATE
      const ed = this.endDATE

      // Log the start and end dates to debug
      console.log("Start Date:", sd);
      console.log("End Date:", ed);
      this.habdFn(sd,ed);
      this.LoadFn(sd,ed);
      this.LoadFn2(sd,ed);
      this.showTable = true;
      this.habdFn(sd, ed);
      this.showscharts = true;
      this.defaultStartDate=this.startDATE
      if (new Date().getMonth() === monthNumber) {
        // If the selected month is the current month, set the default end date to today's date
        this.defaultEndDate = this.formatDate(new Date());
    } else {
        this.defaultEndDate = this.endDATE;
    }
      // this.defaultEndDate=this.endDATE
      this.showssummary = true;
      
      this.show_mvis_summary = false;
      this.show_mvis_false_summary = false;
      

    } else {
      console.error("Invalid month name:", selectedMonth);
    }
  }
},


    reloadPage() {

      location.reload();
    // Trigger functionality to load current date's data
    
      
    },

    validateForm() {
      // Check if all required fields are filled
      return (
        this.formData.train_id &&
        this.formData.tagged_wagon_id &&
        this.formData.def_type &&
        this.formData.photo &&
        this.formData.remarks
      )
    },

    submitForm() {

      if (!this.validateForm()) {
        console.log('Please fill all required fields');
        return; // Exit early if form is not valid
      }
    
      console.log('Form submitted with data:', this.formData.train_id, this.formData.tagged_wagon_id, this.formData.photo, this.formData.remarks, this.formData.def_type.value, this.startdateFormatted, this.selectedTimeFormatted);
      let dateTime = this.startdateFormatted.concat(" ", this.selectedTimeFormatted);
      console.log("DATE AND TIME:", dateTime);
      

      const formData = new FormData();
      formData.append('train_id', this.formData.train_id);
      formData.append('tagged_wagon_id', this.formData.tagged_wagon_id);
      formData.append('remarks', this.formData.remarks);
      formData.append('defType', this.formData.def_type.value);
      formData.append('dateTime', dateTime);
      formData.append('photo', this.formData.photo); // Append the file

      Api().post('api/mvis_update_missed_info', formData) // Update the API endpoint URL
        .then((response) => {
          console.log(response.data);
        })
        .catch(function(error) {
          console.error(error);
          ApiResponse.checkErrorCode(error.response.status);
        });

      // Close the dialog after submission if needed
      this.dialogFN = false;
    },

    rowClickRemarks(row){
      this.selectedRow = row;
      console.log('row', this.selectedRow);
      this.remarks = '';
    },

    updateFeedback(train_id,defect_image, event) {
        // console.log('Old', itm.action_taken);  // Old value
        console.log('act_tkn', event);
        console.log('TRAINID', train_id);
        console.log('DEFECT IMAGE', defect_image);


        this.new_feedback = event;
        // this.img_name = def_img.split('/')[5];
        

        // let fbIndex = this.items_mvis_summary.findIndex((obj => obj.defect_type == this.mvis_defect_code_desc[def_code]));
        // console.log('fbIndex', fbIndex);


       /* if(itm.action_taken === '-') {
          console.log('Old', itm.action_taken);          
          this.items_mvis_summary[fbIndex].feedback_count += 1;
      
          if(event == 'TRUE DEFECT') {
            itm.action_taken = 'TRUE DEFECT';
            this.items_mvis_summary[fbIndex].feedback_true += 1;
            this.items_mvis_summary[fbIndex].true_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_true * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
            this.items_mvis_summary[fbIndex].false_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_false * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);

          } else if (event == 'FALSE POSITIVE') {
            itm.action_taken = 'FALSE POSITIVE';
            this.items_mvis_summary[fbIndex].feedback_false += 1;
            this.items_mvis_summary[fbIndex].true_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_true * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
            this.items_mvis_summary[fbIndex].false_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_false * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
            
          }

        } else if (itm.action_taken == 'TRUE DEFECT') { //prev value is true
          // false positive will be incremented and true count will be decremented
          itm.action_taken = 'FALSE POSITIVE';
          if(this.items_mvis_summary[fbIndex].feedback_true < 0) {
            this.items_mvis_summary[fbIndex].feedback_true = 0;
          } else {
            this.items_mvis_summary[fbIndex].feedback_true -= 1;
          }
          console.log('chk - changed to FALSE? ', itm.action_taken);
          this.items_mvis_summary[fbIndex].feedback_false += 1;
          this.items_mvis_summary[fbIndex].true_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_true * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
          this.items_mvis_summary[fbIndex].false_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_false * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
          
        } else if (itm.action_taken == 'FALSE POSITIVE') { //prev value is false
          // true positive will be incremented and false count will be decremented
          itm.action_taken = 'TRUE DEFECT';
          this.items_mvis_summary[fbIndex].feedback_true += 1;
          if(this.items_mvis_summary[fbIndex].feedback_false < 0) {
            this.items_mvis_summary[fbIndex].feedback_false = 0;
          } else {
            this.items_mvis_summary[fbIndex].feedback_false -= 1;
          }
          this.items_mvis_summary[fbIndex].true_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_true * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
          this.items_mvis_summary[fbIndex].false_percentage = parseFloat((this.items_mvis_summary[fbIndex].feedback_false * 100) / this.items_mvis_summary[fbIndex].mvis_alert_count).toFixed(2);
          
        }
 
        else {
        //Nothing
        }
          

        console.log("count obj", this.feedback_true, this.act_tkn, this.feedback_false);*/

        let img_name = defect_image.split('/')[5];
        console.log("train_id, def_ig and action taken:",train_id,defect_image);
        Api().post('api/mvis_update_feedback', {
            trainId: train_id,
            def_img: img_name,
            act_tkn: event
              })
              .then((response) => {
                   console.log(response.data);
                   
                  })
                .catch(function (error) {
                    // console.log(error);
                    ApiResponse.checkErrorCode(error.response.status);
                });
      },


      updateFieldReport(train_id,defect_image, event) {
        // console.log('Old', itm.action_taken);  // Old value
        console.log('field_report', event);
        console.log('TRAINID', train_id);
        console.log('DEFECT IMAGE', defect_image);


        this.new_fieldreport = event;
        let img_name = defect_image.split('/')[5];
        console.log("train_id, def_img and fieldReport:",train_id,img_name,this.new_fieldreport);
        Api().post('api/mvis_update_field_report', {
            train_id: train_id,
            defect_image: img_name,
            field_report: event
              })
              .then((response) => {
                   console.log("FIELD REPORTTT",response.data);
                   
                  })
                .catch(function (error) {
                    // console.log(error);
                    ApiResponse.checkErrorCode(error.response.status);
                });
      },

    acknowledgeit(){
      this.$router.push(({ name: 'Train Consolidated Report', params: { } }));
    },

    async dashboardFn() {

      this.bottom = !!(window.screen.availHeight < 1000 && window.screen.availWidth < 500);
      this.top = !!(window.screen.availHeight > 1000 && window.screen.availWidth > 500);

      // var { date1, date2 } = this.getStartEndDate();
      // console.log(date1,date2);
      this.fb_month_list.length = 0;
      this.startDate = this.startdateFormatted;
      this.endDate = this.enddateFormatted;
      this.def_1.length = 0;
      this.def_2.length = 0;
      this.def_3.length = 0;
      this.def_4.length = 0;
      this.def_5.length = 0;
      this.def_6.length = 0;
      this.def_7.length = 0;
      this.def_8.length = 0;
      this.def_9.length = 0;

      console.log('startDate - endDate', this.startDate, this.endDate);
      if(this.startDate && this.endDate){
        this.startDate = this.startDate
        this.endDate = this.endDate
        } else {
          this.startDate = this.startDate
          this.endDate = this.endDate
        }
  
      var partsStart = this.startDate.split("-");
      var partsEnd = this.endDate.split("-");
  
        
        var dayS = partsStart[0];
        var monthS = partsStart[1];
        var yearS = partsStart[2];
        var dayE = partsEnd[0];
        var monthE = partsEnd[1];
        var yearE = partsEnd[2];
        
  
        // Pad month and day with leading zeros if necessary
        if (monthS.length === 1) {
            monthS = '0' + monthS;
        }
        if (dayS.length === 1) {
            dayS = '0' + day;
        }
        if (monthE.length === 1) {
          monthE = '0' + monthE;
        }
        if (dayE.length === 1) {
          dayE = '0' + dayE;
        }
  
        // Format the train id
        var trainIdFormatStart = 'T' + yearS + monthS + dayS + '000000';
        var trainIdFormatEnd = 'T' + yearE + monthE + dayE + '235959';
        console.log("TRAINID:",trainIdFormatStart,trainIdFormatEnd)

      /*var dateStr = date2.split("-").slice();
      var dateT = dateStr[2]
      var monT1 = dateStr[1]
      var yearT = dateStr[0]*/
      await Api().post('/api/dashboard', {
        start1: this.startDate,
        end1: this.endDate,
        trainIdFormatStart:trainIdFormatStart,
        trainIdFormatEnd: trainIdFormatEnd,
        
      }).then(response => {
        this.dashboard = response.data;
        console.log("DATEEEEE" ,this.startDate,this.endDate);
        // console.log("RESPONSE.DATA VALUES:", response.data);
        console.log('FEEDBACK NOT GIVEN DATA:',this.dashboard.monthDefectCount);
        console.log("$store.state.ackStatus", this.dashboard.current_day_alarm_count);
        // console.log("current_day_no_fb_count",this.dashboard.current_day_no_fb_count);
        
        this.fb_not_given_result = this.dashboard.monthDefectCount; // changed here
        this.def_1 = this.dashboard.def_1;
        this.def_2 = this.dashboard.def_2;
        this.def_3 = this.dashboard.def_3;
        this.def_4 = this.dashboard.def_4;
        this.def_5 = this.dashboard.def_5;
        this.def_6 = this.dashboard.def_6;
        this.def_7 = this.dashboard.def_7;
        this.def_8 = this.dashboard.def_8;
        this.def_9 = this.dashboard.def_9;
        this.current_day_train_info = this.dashboard.current_day_train_info;
        this.current_day_train_count = this.dashboard.current_day_train_count;
        this.current_week_train_count = this.dashboard.current_week_train_count;
        this.prev_month_train_count = this.dashboard.prev_month_train_count;
        this.current_month_train_count = this.dashboard.current_month_train_count;
        this.current_day_defect_count = this.dashboard.current_day_defect_count;
        this.prev_week_defect_count = this.dashboard.prev_week_defect_count;
        this.prev_month_defect_count = this.dashboard.prev_month_defect_count;
        this.current_month_defect_count = this.dashboard.current_month_defect_count;
        this.current_day_wagon_count = this.dashboard.current_day_wagon_count;
        this.prev_week_wagon_count = this.dashboard.prev_week_wagon_count;
        this.prev_month_wagon_count = this.dashboard.prev_month_wagon_count;
        this.current_month_wagon_count = this.dashboard.current_month_wagon_count;
        this.current_day_alarm_count = this.dashboard.current_day_alarm_count;
        this.prev_week_alarm_count = this.dashboard.prev_week_alarm_count;
        this.prev_month_alarm_count = this.dashboard.prev_month_alarm_count;
        this.current_month_alarm_count = this.dashboard.current_month_alarm_count;
        console.log("CHECK THE DEF_7:",this.week_date_list_6,this.week_train_count_list_7,this.week_defect_count_list_7)

        this.week_date_list = this.def_1.map(row => row[0]);
        this.week_train_count_list = this.def_1.map(row => row[1]);
        this.week_defect_count_list = this.def_1.map(row => row[2]);

        this.week_date_list_2 = this.def_2.map(row => row[0]);
        this.week_train_count_list_2 = this.def_2.map(row => row[1]);
        this.week_defect_count_list_2 = this.def_2.map(row => row[2]);

        this.week_date_list_3 = this.def_3.map(row => row[0]);
        let def_3_traincount_A = this.def_3.map(row => row[1])
        let def_4_traincount_B = this.def_4.map(row => row[1])
        let combined_arr_traincount1=[];
        for (let i = 0; i < def_3_traincount_A.length; i++) {
          let value_traincount_A = typeof def_3_traincount_A[i] === 'undefined' ? 0 : def_3_traincount_A[i];
          let value_traincount_B = typeof def_4_traincount_B[i] === 'undefined' ? 0 : def_4_traincount_B[i];
          let sum = value_traincount_A + value_traincount_B;
          combined_arr_traincount1.push(sum);
        }
        console.log('3rd DEF',def_3_traincount_A)
        console.log("COMBINED :",combined_arr_traincount1)
 
        let def_3_defectcount_A = this.def_3.map(row => row[2])
        let def_4_defectcount_B = this.def_4.map(row => row[2])
        let combined_arr_defectcount1=[];
        for (let i = 0; i < def_3_defectcount_A.length; i++) {
          let value_defectcount_A = typeof def_3_defectcount_A[i] === 'undefined' ? 0 : def_3_defectcount_A[i];
          let value_defectcount_B = typeof def_4_defectcount_B[i] === 'undefined' ? 0 : def_4_defectcount_B[i];
          let sum = value_defectcount_A + value_defectcount_B;
          combined_arr_defectcount1.push(sum);
        }
        console.log("COMBINED :",combined_arr_defectcount1)
        this.week_train_count_list_3 = combined_arr_traincount1;
        this.week_defect_count_list_3 = combined_arr_defectcount1;
        console.log("CHECK1 :",this.week_train_count_list_3)
        console.log("CHECK2 :",this.week_train_count_list_2)


        //Axle box cover and End cap screw(s)
        this.week_date_list_5 = this.def_5.map(row => row[0]);
        this.week_train_count_list_5 = this.def_5.map(row => row[1]);
        this.week_defect_count_list_5 = this.def_5.map(row => row[2]);

        this.week_date_list_6 = this.def_6.map(row => row[0]);
        this.week_train_count_list_6 = this.def_6.map(row => row[1]);
        this.week_defect_count_list_6 = this.def_6.map(row => row[2]);
        // this.week_date_list_5 = this.def_5.map(row => row[0]);
        // let def_5_traincount_A = this.def_5.map(row => row[1])
        // let def_6_traincount_B = this.def_6.map(row => row[1])
        // let combined_arr_traincount2=[];
        // for (let i = 0; i < def_5_traincount_A.length; i++) {
        //   let value_traincount_A_def5 = typeof def_5_traincount_A[i] === 'undefined' ? 0 : def_5_traincount_A[i];
        //   let value_traincount_B_def6 = typeof def_6_traincount_B[i] === 'undefined' ? 0 : def_6_traincount_B[i];
        //   let sum_def5 = value_traincount_A_def5 + value_traincount_B_def6;
        //   combined_arr_traincount2.push(sum_def5);
        // }
        // console.log('5TH DEF',def_5_traincount_A)
        // console.log("COMBINED :",combined_arr_traincount2)
 
        // let def_5_defectcount_A = this.def_5.map(row => row[2])
        // let def_6_defectcount_B = this.def_6.map(row => row[2])
        // let combined_arr_defectcount2=[];
        // for (let i = 0; i < def_5_defectcount_A.length; i++) {
        //   let value_defectcount_A_def5 = typeof def_5_defectcount_A[i] === 'undefined' ? 0 : def_5_defectcount_A[i];
        //   let value_defectcount_B_def5 = typeof def_6_defectcount_B[i] === 'undefined' ? 0 : def_6_defectcount_B[i];
        //   let sum_def5_1 = value_defectcount_A_def5 + value_defectcount_B_def5;
        //   combined_arr_defectcount2.push(sum_def5_1);
        // }
        // console.log("COMBINED :",combined_arr_defectcount2)
        // this.week_train_count_list_5 = combined_arr_traincount2;
        // this.week_defect_count_list_5 = combined_arr_defectcount2;
        // console.log("CHECK1 :",this.week_train_count_list_5)
        // console.log("CHECK2 :",this.week_train_count_list_3)


        // // this.week_date_list_6 = this.def_6.map(row => row[0]);
        // this.week_train_count_list_6 = this.def_6.map(row => row[1]);
        // this.week_defect_count_list_6 = this.def_6.map(row => row[2]);

        this.week_date_list_7 = this.def_7.map(row => row[0]);
        this.week_train_count_list_7 = this.def_7.map(row => row[1]);
        this.week_defect_count_list_7 = this.def_7.map(row => row[2]);

        this.week_date_list_8 = this.def_8.map(row => row[0]);
        this.week_train_count_list_8 = this.def_8.map(row => row[1]);
        this.week_defect_count_list_8 = this.def_8.map(row => row[2]);

        this.week_date_list_9 = this.def_9.map(row => row[0]);
        this.week_train_count_list_9 = this.def_9.map(row => row[1]);
        this.week_defect_count_list_9 = this.def_9.map(row => row[2]);

        this.def_1.length = 0;
        this.def_2.length = 0;
        this.def_3.length = 0;
        this.def_4.length = 0;
        this.def_5.length = 0;
        this.def_6.length = 0;
        this.def_7.length = 0;
        this.def_8.length = 0;
        this.def_9.length = 0;
        this.fb_month_list.length = 0 //changed here
        this.current_day_whole_info.length = 0
        this.$store.state.trainCount.length = 0
        this.$store.state.defectCount.length = 0
        this.$store.state.barChartDates.length = 0

        this.$store.state.trainCount2.length = 0
        this.$store.state.defectCount2.length = 0
        this.$store.state.barChartDates2.length = 0 //clear the array

        this.$store.state.trainCount3.length = 0
        this.$store.state.defectCount3.length = 0
        this.$store.state.barChartDates3.length = 0 //clear the array

        // this.$store.state.trainCount4.length = 0
        // this.$store.state.defectCount4.length = 0
        // this.$store.state.barChartDates4.length = 0 //clear the array

        this.$store.state.trainCount5.length = 0
        this.$store.state.defectCount5.length = 0
        this.$store.state.barChartDates5.length = 0 //clear the array

        this.$store.state.trainCount6.length = 0
        this.$store.state.defectCount6.length = 0
        this.$store.state.barChartDates6.length = 0 //clear the array

        this.$store.state.trainCount7.length = 0
        this.$store.state.defectCount7.length = 0
        this.$store.state.barChartDates7.length = 0 //clear the array

        this.$store.state.trainCount8.length = 0
        this.$store.state.defectCount8.length = 0
        this.$store.state.barChartDates8.length = 0 //clear the array

        this.$store.state.trainCount9.length = 0
        this.$store.state.defectCount9.length = 0
        this.$store.state.barChartDates9.length = 0 //clear the array

	      this.$store.state.ackStatus = this.current_day_defect_count; 
        this.$store.state.barChartDates.push(...this.week_date_list);
        this.$store.state.trainCount.push(...this.week_train_count_list);
        this.$store.state.defectCount.push(...this.week_defect_count_list);

        this.$store.state.barChartDates2.push(...this.week_date_list_2);
        this.$store.state.trainCount2.push(...this.week_train_count_list_2);
        this.$store.state.defectCount2.push(...this.week_defect_count_list_2);

        this.$store.state.barChartDates3.push(...this.week_date_list_3);
        this.$store.state.trainCount3.push(...this.week_train_count_list_3);
        this.$store.state.defectCount3.push(...this.week_defect_count_list_3);

        // this.$store.state.barChartDates4.push(...this.week_date_list_4);
        // this.$store.state.trainCount4.push(...this.week_train_count_list_4);
        // this.$store.state.defectCount4.push(...this.week_defect_count_list_4);

        this.$store.state.barChartDates5.push(...this.week_date_list_5);
        this.$store.state.trainCount5.push(...this.week_train_count_list_5);
        this.$store.state.defectCount5.push(...this.week_defect_count_list_5);

        this.$store.state.barChartDates6.push(...this.week_date_list_6);
        this.$store.state.trainCount6.push(...this.week_train_count_list_6);
        this.$store.state.defectCount6.push(...this.week_defect_count_list_6);

        this.$store.state.barChartDates7.push(...this.week_date_list_7);
        this.$store.state.trainCount7.push(...this.week_train_count_list_7);
        this.$store.state.defectCount7.push(...this.week_defect_count_list_7);

        this.$store.state.barChartDates8.push(...this.week_date_list_8);
        this.$store.state.trainCount8.push(...this.week_train_count_list_8);
        this.$store.state.defectCount8.push(...this.week_defect_count_list_8);

        this.$store.state.barChartDates9.push(...this.week_date_list_9);
        this.$store.state.trainCount9.push(...this.week_train_count_list_9);
        this.$store.state.defectCount9.push(...this.week_defect_count_list_9);

        // console.log('graphsValues: def_1', this.def_1, this.week_date_list_2, this.week_train_count_list_2, this.week_defect_count_list_2);
        //MADE CHANGES HERE 
        
        for (let i in this.fb_not_given_result){
          this.fb_month_list.push({
            'month': this.fb_not_given_result[i][0],
	          'total_trains_passed': this.fb_not_given_result[i][1],
            'total_alerts': this.fb_not_given_result[i][2],
            'feedbackavailable': this.fb_not_given_result[i][3],
            'alerts_per_train': Math.ceil(this.fb_not_given_result[i][2] / this.fb_not_given_result[i][1]),
            'true_alerts': this.fb_not_given_result[i][4], 
            'false_alerts': this.fb_not_given_result[i][5],      
            'ratio_true_false': parseInt(this.fb_not_given_result[i][5] * 100 / this.fb_not_given_result[i][2]),
            'mvis_up_time': '100%',
          })
        }
        console.log("FB NOT GIVEN LIST : ", this.fb_month_list);

        for (let i in this.current_day_train_info) {
          this.current_day_whole_info.push({
            'train_id': this.current_day_train_info[i][0],
            'dfis_train_id': this.current_day_train_info[i][1],
            'direction': this.current_day_train_info[i][2],
            'entry_time': this.current_day_train_info[i][3],
            'exit_time': this.current_day_train_info[i][4],
            'train_speed': this.current_day_train_info[i][5],
            'tagged_wagon_id': this.current_day_train_info[i][6],
            'tagged_bogie_id': this.current_day_train_info[i][7],
            'defect_code': this.current_day_train_info[i][8],
            'side': this.current_day_train_info[i][9],
          })
        }

      }).catch(error => {
        ApiResponse.checkErrorCode(error.response.status);
      })
    },


    async LoadFn(startdate,enddate) {

    this.bottom = !!(window.screen.availHeight < 1000 && window.screen.availWidth < 500);
    this.top = !!(window.screen.availHeight > 1000 && window.screen.availWidth > 500);

    // var { date1, date2 } = this.getStartEndDate();
    // console.log(date1,date2);
    this.fb_month_list.length = 0;
    // this.startDate = startdate
    // this.endDate = enddate

    console.log('startDateeee - endDateeee', startdate, enddate);
    var partsStart = startdate.split("-");
      var partsEnd = enddate.split("-");
  
        
        var dayS = partsStart[0];
        var monthS = partsStart[1];
        var yearS = partsStart[2];
        var dayE = partsEnd[0];
        var monthE = partsEnd[1];
        var yearE = partsEnd[2];
        
  
        // Pad month and day with leading zeros if necessary
        if (monthS.length === 1) {
            monthS = '0' + monthS;
        }
        if (dayS.length === 1) {
            dayS = '0' + day;
        }
        if (monthE.length === 1) {
          monthE = '0' + monthE;
        }
        if (dayE.length === 1) {
          dayE = '0' + dayE;
        }
  
        // Format the train id
        var trainIdFormatStart = 'T' + yearS + monthS + dayS + '000000';
        var trainIdFormatEnd = 'T' + yearE + monthE + dayE + '235959';
        console.log("TRAINID:",trainIdFormatStart,trainIdFormatEnd)


    /*var dateStr = date2.split("-").slice();
    var dateT = dateStr[2]
    var monT1 = dateStr[1]
    var yearT = dateStr[0]*/
    await Api().post('/api/habdMgr', {
      start1: startdate,
      end1: enddate,
      trainIdFormatStart: trainIdFormatStart,
      trainIdFormatEnd: trainIdFormatEnd
      
    }).then(response => {
      this.dashboard = response.data;
      console.log("DATEEEEE" ,startdate,enddate);
      // console.log("RESPONSE.DATA VALUES:", response.data);
      console.log('FEEDBACK NOT GIVEN DATA:',this.dashboard.monthDefectCount);
        
      this.fb_not_given_result = this.dashboard.monthDefectCount; // changed here
      
      this.fb_month_list.length = 0 //changed here
      
      //MADE CHANGES HERE 
      
      for (let i in this.fb_not_given_result){
        this.fb_month_list.push({
          'month': this.fb_not_given_result[i][0],
          'total_trains_passed': this.fb_not_given_result[i][1],
          'total_alerts': this.fb_not_given_result[i][2],
          'feedbackavailable': this.fb_not_given_result[i][3],
          'alerts_per_train': Math.ceil(this.fb_not_given_result[i][2] / this.fb_not_given_result[i][1]),
          'true_alerts': this.fb_not_given_result[i][4], 
          'false_alerts': this.fb_not_given_result[i][5],      
          'ratio_true_false': parseInt(this.fb_not_given_result[i][5] * 100 / this.fb_not_given_result[i][2]),
          'mvis_up_time': '100%',
        })
      }
      console.log("FB NOT GIVEN LIST : ", this.fb_month_list);

    }).catch(error => {
      ApiResponse.checkErrorCode(error.response.status);
    })
    },



    async LoadFn2(startdate,enddate) {

        this.bottom = !!(window.screen.availHeight < 1000 && window.screen.availWidth < 500);
        this.top = !!(window.screen.availHeight > 1000 && window.screen.availWidth > 500);

        this.def_1.length = 0;
        this.def_2.length = 0;
        this.def_3.length = 0;
        this.def_4.length = 0;
        this.def_5.length = 0;
        this.def_6.length = 0;
        this.def_7.length = 0;
        this.def_8.length = 0;
        this.def_9.length = 0;

        console.log('startDateeee - endDateeee', startdate, enddate);
        var partsStart = startdate.split("-");
      var partsEnd = enddate.split("-");
  
        
        var dayS = partsStart[0];
        var monthS = partsStart[1];
        var yearS = partsStart[2];
        var dayE = partsEnd[0];
        var monthE = partsEnd[1];
        var yearE = partsEnd[2];
        
  
        // Pad month and day with leading zeros if necessary
        if (monthS.length === 1) {
            monthS = '0' + monthS;
        }
        if (dayS.length === 1) {
            dayS = '0' + day;
        }
        if (monthE.length === 1) {
          monthE = '0' + monthE;
        }
        if (dayE.length === 1) {
          dayE = '0' + dayE;
        }
  
        // Format the train id
        var trainIdFormatStart = 'T' + yearS + monthS + dayS + '000000';
        var trainIdFormatEnd = 'T' + yearE + monthE + dayE + '235959';
        console.log("TRAINID:",trainIdFormatStart,trainIdFormatEnd)

        
        /*var dateStr = date2.split("-").slice();
        var dateT = dateStr[2]
        var monT1 = dateStr[1]
        var yearT = dateStr[0]*/
        await Api().post('/api/habdMgr2', {
          start1: startdate,
          end1: enddate,
          trainIdFormatStart:trainIdFormatStart,
          trainIdFormatEnd:trainIdFormatEnd,
          
        }).then(response => {
          this.dashboard = response.data;
          console.log("checkingggggg:",this.dashboard)
          console.log("DATEEEEE" ,startdate,enddate);
          // console.log("RESPONSE.DATA VALUES:", response.data);
          this.def_1 = this.dashboard.def_1;
          this.def_2 = this.dashboard.def_2;
          this.def_3 = this.dashboard.def_3;
          this.def_4 = this.dashboard.def_4;
          this.def_5 = this.dashboard.def_5;
          this.def_6 = this.dashboard.def_6;
          this.def_7 = this.dashboard.def_7;
          this.def_8 = this.dashboard.def_8;
          this.def_9 = this.dashboard.def_9;
          this.week_date_list = this.def_1.map(row => row[0]);
          this.week_train_count_list = this.def_1.map(row => row[1]);
          this.week_defect_count_list = this.def_1.map(row => row[2]);

          this.week_date_list_2 = this.def_2.map(row => row[0]);
          this.week_train_count_list_2 = this.def_2.map(row => row[1]);
          this.week_defect_count_list_2 = this.def_2.map(row => row[2]);

          this.week_date_list_3 = this.def_3.map(row => row[0]);
          let def_3_traincount_A = this.def_3.map(row => row[1])
          let def_4_traincount_B = this.def_4.map(row => row[1])
          let combined_arr_traincount1=[];
          for (let i = 0; i < def_3_traincount_A.length; i++) {
            let value_traincount_A = typeof def_3_traincount_A[i] === 'undefined' ? 0 : def_3_traincount_A[i];
            let value_traincount_B = typeof def_4_traincount_B[i] === 'undefined' ? 0 : def_4_traincount_B[i];
            let sum = value_traincount_A + value_traincount_B;
            combined_arr_traincount1.push(sum);
          }
          console.log('3rd DEF',def_3_traincount_A)
          console.log("COMBINED :",combined_arr_traincount1)
  
          let def_3_defectcount_A = this.def_3.map(row => row[2])
          let def_4_defectcount_B = this.def_4.map(row => row[2])
          let combined_arr_defectcount1=[];
          for (let i = 0; i < def_3_defectcount_A.length; i++) {
            let value_defectcount_A = typeof def_3_defectcount_A[i] === 'undefined' ? 0 : def_3_defectcount_A[i];
            let value_defectcount_B = typeof def_4_defectcount_B[i] === 'undefined' ? 0 : def_4_defectcount_B[i];
            let sum = value_defectcount_A + value_defectcount_B;
            combined_arr_defectcount1.push(sum);
          }
          console.log("COMBINED :",combined_arr_defectcount1)
          this.week_train_count_list_3 = combined_arr_traincount1;
          this.week_defect_count_list_3 = combined_arr_defectcount1;
          console.log("CHECK1 :",this.week_train_count_list_3)
          console.log("CHECK2 :",this.week_train_count_list_2)


          //Axle box cover and End cap screw(s)
          // this.week_date_list_5 = this.def_5.map(row => row[0]);
          // let def_5_traincount_A = this.def_5.map(row => row[1])
          // let def_6_traincount_B = this.def_6.map(row => row[1])
          // let combined_arr_traincount2=[];
          // for (let i = 0; i < def_5_traincount_A.length; i++) {
          //   let value_traincount_A_def5 = typeof def_5_traincount_A[i] === 'undefined' ? 0 : def_5_traincount_A[i];
          //   let value_traincount_B_def6 = typeof def_6_traincount_B[i] === 'undefined' ? 0 : def_6_traincount_B[i];
          //   let sum_def5 = value_traincount_A_def5 + value_traincount_B_def6;
          //   combined_arr_traincount2.push(sum_def5);
          // }
          // console.log('5TH DEF',def_5_traincount_A)
          // console.log("COMBINED :",combined_arr_traincount2)
  
          // let def_5_defectcount_A = this.def_5.map(row => row[2])
          // let def_6_defectcount_B = this.def_6.map(row => row[2])
          // let combined_arr_defectcount2=[];
          // for (let i = 0; i < def_5_defectcount_A.length; i++) {
          //   let value_defectcount_A_def5 = typeof def_5_defectcount_A[i] === 'undefined' ? 0 : def_5_defectcount_A[i];
          //   let value_defectcount_B_def5 = typeof def_6_defectcount_B[i] === 'undefined' ? 0 : def_6_defectcount_B[i];
          //   let sum_def5_1 = value_defectcount_A_def5 + value_defectcount_B_def5;
          //   combined_arr_defectcount2.push(sum_def5_1);
          // }
          // console.log("COMBINED :",combined_arr_defectcount2)
          // this.week_train_count_list_5 = combined_arr_traincount2;
          // this.week_defect_count_list_5 = combined_arr_defectcount2;
          // console.log("CHECK1 :",this.week_train_count_list_5)
          // console.log("CHECK2 :",this.week_train_count_list_3)

          this.week_date_list_5 = this.def_5.map(row => row[0]);
          this.week_train_count_list_5 = this.def_5.map(row => row[1]);
          this.week_defect_count_list_5 = this.def_5.map(row => row[2]);

          this.week_date_list_6 = this.def_6.map(row => row[0]);
          this.week_train_count_list_6 = this.def_6.map(row => row[1]);
          this.week_defect_count_list_6 = this.def_6.map(row => row[2]);

          this.week_date_list_7 = this.def_7.map(row => row[0]);
          this.week_train_count_list_7 = this.def_7.map(row => row[1]);
          this.week_defect_count_list_7 = this.def_7.map(row => row[2]);

          this.week_date_list_8 = this.def_8.map(row => row[0]);
          this.week_train_count_list_8 = this.def_8.map(row => row[1]);
          this.week_defect_count_list_8 = this.def_8.map(row => row[2]);

          this.week_date_list_9 = this.def_9.map(row => row[0]);
          this.week_train_count_list_9 = this.def_9.map(row => row[1]);
          this.week_defect_count_list_9 = this.def_9.map(row => row[2]);

          this.def_1.length = 0;
          this.def_2.length = 0;
          this.def_3.length = 0;
          this.def_4.length = 0;
          this.def_5.length = 0;
          this.def_6.length = 0;
          this.def_7.length = 0;
          this.def_8.length = 0;
          this.def_9.length = 0;
          this.fb_month_list.length = 0 //changed here
          this.current_day_whole_info.length = 0
          this.$store.state.trainCount.length = 0
          this.$store.state.defectCount.length = 0
          this.$store.state.barChartDates.length = 0

          this.$store.state.trainCount2.length = 0
          this.$store.state.defectCount2.length = 0
          this.$store.state.barChartDates2.length = 0 //clear the array

          this.$store.state.trainCount3.length = 0
          this.$store.state.defectCount3.length = 0
          this.$store.state.barChartDates3.length = 0 //clear the array

          // this.$store.state.trainCount4.length = 0
          // this.$store.state.defectCount4.length = 0
          // this.$store.state.barChartDates4.length = 0 //clear the array

          this.$store.state.trainCount5.length = 0
          this.$store.state.defectCount5.length = 0
          this.$store.state.barChartDates5.length = 0 //clear the array

          this.$store.state.trainCount6.length = 0
          this.$store.state.defectCount6.length = 0
          this.$store.state.barChartDates6.length = 0 //clear the array

          this.$store.state.trainCount7.length = 0
          this.$store.state.defectCount7.length = 0
          this.$store.state.barChartDates7.length = 0 //clear the array

          this.$store.state.trainCount8.length = 0
          this.$store.state.defectCount8.length = 0
          this.$store.state.barChartDates8.length = 0 //clear the array

          this.$store.state.trainCount9.length = 0
          this.$store.state.defectCount9.length = 0
          this.$store.state.barChartDates9.length = 0 //clear the array

          this.$store.state.ackStatus = this.current_day_defect_count; 
          this.$store.state.barChartDates.push(...this.week_date_list);
          this.$store.state.trainCount.push(...this.week_train_count_list);
          this.$store.state.defectCount.push(...this.week_defect_count_list);

          this.$store.state.barChartDates2.push(...this.week_date_list_2);
          this.$store.state.trainCount2.push(...this.week_train_count_list_2);
          this.$store.state.defectCount2.push(...this.week_defect_count_list_2);

          this.$store.state.barChartDates3.push(...this.week_date_list_3);
          this.$store.state.trainCount3.push(...this.week_train_count_list_3);
          this.$store.state.defectCount3.push(...this.week_defect_count_list_3);

          // this.$store.state.barChartDates4.push(...this.week_date_list_4);
          // this.$store.state.trainCount4.push(...this.week_train_count_list_4);
          // this.$store.state.defectCount4.push(...this.week_defect_count_list_4);

          this.$store.state.barChartDates5.push(...this.week_date_list_5);
          this.$store.state.trainCount5.push(...this.week_train_count_list_5);
          this.$store.state.defectCount5.push(...this.week_defect_count_list_5);

          this.$store.state.barChartDates6.push(...this.week_date_list_6);
          this.$store.state.trainCount6.push(...this.week_train_count_list_6);
          this.$store.state.defectCount6.push(...this.week_defect_count_list_6);

          this.$store.state.barChartDates7.push(...this.week_date_list_7);
          this.$store.state.trainCount7.push(...this.week_train_count_list_7);
          this.$store.state.defectCount7.push(...this.week_defect_count_list_7);

          this.$store.state.barChartDates8.push(...this.week_date_list_8);
          this.$store.state.trainCount8.push(...this.week_train_count_list_8);
          this.$store.state.defectCount8.push(...this.week_defect_count_list_8);

          this.$store.state.barChartDates9.push(...this.week_date_list_9);
          this.$store.state.trainCount9.push(...this.week_train_count_list_9);
          this.$store.state.defectCount9.push(...this.week_defect_count_list_9);

          

        }).catch(error => {
          ApiResponse.checkErrorCode(error.response.status);
        })
        },

    async habdFn(startdate , enddate) {
      console.log('on click?');
      this.tableValues=[];
      this.totalObjArr = [];
      this.exelArr = [];
      let mergedVal = [];
      this.habd_results_arr = [];
      let trueCount = 0;
      let falseCount = 0;
      let feedbackCount = 0;
      let truePercentage = '-';
      let falsePercentage = '-';
      // if(startDate && endDate){
      //   startDate = startDate
      //   endDate = endDate
      // } else {
      //   startDate = this.startDate
      //   endDate = this.endDate
      // }

      var partsStart = startdate.split("-");
      var partsEnd = enddate.split("-");
  
        
        var dayS = partsStart[0];
        var monthS = partsStart[1];
        var yearS = partsStart[2];
        var dayE = partsEnd[0];
        var monthE = partsEnd[1];
        var yearE = partsEnd[2];
        
  
        // Pad month and day with leading zeros if necessary
        if (monthS.length === 1) {
            monthS = '0' + monthS;
        }
        if (dayS.length === 1) {
            dayS = '0' + day;
        }
        if (monthE.length === 1) {
          monthE = '0' + monthE;
        }
        if (dayE.length === 1) {
          dayE = '0' + dayE;
        }
  
        // Format the train id
        var trainIdFormatStart = 'T' + yearS + monthS + dayS + '000000';
        var trainIdFormatEnd = 'T' + yearE + monthE + dayE + '235959';
        console.log("TRAINID:",trainIdFormatStart,trainIdFormatEnd)

      await Api().post('/api/habdDetection', {
        start: startdate,
          end: enddate,
          trainIdFormatStart:trainIdFormatStart,
          trainIdFormatEnd: trainIdFormatEnd,
	// trainIdFormat: trainIdFormat,
      }).then(async response1 => {
        console.log('on click? - habdDetection');
        let count = 0;
        this.tableValues = [];
        this.totalObjArr = [];
        this.exelArr = [];
        this.habd_results_arr = [];
        this.$store.state.seriesPie.length = 0
        this.$store.state.seriestruePer.length = 0
        this.$store.state.seriesTotalTrue.length = 0
        this.$store.state.seriesTotalFalse.length = 0
        this.habd_results_arr = response1.data.habd_results_arr;

        console.log('habd_results_arr', response1.data.habd_results_arr);
        console.log('habd_results_total', response1.data.habd_results_total);
        console.log('habd_results_total', response1.data.habd_results_total[0].detail);
        this.totaltrains = response1.data.habd_results_total[0].detail;

        let dashboard_names = ['Summary', 'Hanging Part (side view)','Hanging Part (Undercarriage)','Spring Assembly','Axle box cover','End cap screw(s)','Yoke pin support plate bolts','EM Pad','Wagon Door'];
        for(let val in this.habd_results_arr)
        {
          if(this.habd_results_arr[val].true != '-') {
            trueCount += parseInt(this.habd_results_arr[val].true)
          } else {
            trueCount += 0
          }
          if(this.habd_results_arr[val].false != '-') {
            falseCount += parseInt(this.habd_results_arr[val].false)
          } else {
            falseCount += 0
          }
          if(this.habd_results_arr[val].percentageTrue != '-') {
            truePercentage += this.habd_results_arr[val].percentageTrue
          } else {
            truePercentage += 0
          }
          if(this.habd_results_arr[val].percentageFalse != '-') {
            falsePercentage += this.habd_results_arr[val].percentageFalse
          } else {
            falsePercentage += 0
          }
          if(this.habd_results_arr[val].feedback != '-') {
            feedbackCount += parseInt(this.habd_results_arr[val].feedback);
          } else {
            feedbackCount += 0
          }
        }
        for(let val in this.habd_results_arr)
        {
          count++;         
          if(count>3) {
            this.$store.state.seriesPie.push(this.habd_results_arr[val].percentageFalse)
            this.$store.state.seriestruePer.push(this.habd_results_arr[val].percentageTrue)
          }
          else if(count == 0) {

            this.habd_results_arr[val].true = trueCount
            this.habd_results_arr[val].false = falseCount
            this.habd_results_arr[val].feedback = feedbackCount
            
            if(this.habd_results_arr[2].detail != 0) {
              this.habd_results_arr[val].percentageTrue = (this.habd_results_arr[2].true*100/this.habd_results_arr[2].detail).toFixed(2)
              this.habd_results_arr[val].percentageFalse = (this.habd_results_arr[2].false*100/this.habd_results_arr[2].detail).toFixed(2)

            } else {
              this.habd_results_arr[val].percentageTrue = 0
              this.habd_results_arr[val].percentageFalse = 0
            }

            this.$store.state.seriesTotalTrue.push(this.habd_results_arr[val].percentageTrue);
            this.$store.state.seriesTotalFalse.push(this.habd_results_arr[val].percentageFalse);  
            
          }               

          let totalObj = {'totalTrain': response1.data.habd_results_total[0].detail }
          let obj = {'sno': count, 'totalVerified': this.habd_results_arr[val].verified, 'details':dashboard_names[val],'totalno':this.habd_results_arr[val].detail,'feedbackavailable':this.habd_results_arr[val].feedback, 'trueCount':this.habd_results_arr[val].true,'falsePositive':this.habd_results_arr[val].false,'percentageFalse':this.habd_results_arr[val].percentageFalse}          
          
          this.tableValues.push(obj);
          this.totalObjArr.push(totalObj);
          // console.log("TOTAL OBJECT ARRAYYY:",this.totalObjArr)
           
        }

        this.tableValues[0].totalVerified = this.tableValues[0].totalVerified
        this.tableValues[0].totalno = this.tableValues[0].totalno[0][0]
        this.tableValues[0].feedbackavailable = this.tableValues[0].feedbackavailable
        this.tableValues[0].trueCount = this.tableValues[0].trueCount
        this.tableValues[0].falsePositive = this.tableValues[0].falsePositive
        this.tableValues[0].percentageTrue = this.tableValues[0].percentageTrue
        if(this.tableValues[0].percentageFalse > 0) {
          this.tableValues[0].percentageFalse = this.tableValues[0].percentageFalse
        } else {
          this.tableValues[0].percentageFalse = '0'
        }

        this.tableValues[1].totalVerified = this.tableValues[1].totalVerified
        this.tableValues[1].totalno = this.tableValues[1].totalno
        this.tableValues[1].feedbackavailable = this.tableValues[1].feedbackavailable
        this.tableValues[1].trueCount = this.tableValues[1].trueCount
        this.tableValues[1].falsePositive = this.tableValues[1].falsePositive
        this.tableValues[1].percentageTrue = this.tableValues[1].percentageTrue
        if(this.tableValues[1].percentageFalse > 0) {
          this.tableValues[1].percentageFalse = this.tableValues[1].percentageFalse
        } else {
          this.tableValues[1].percentageFalse = '0'
        }

        this.tableValues[2].totalVerified = this.tableValues[2].totalVerified
        this.tableValues[2].totalno = this.tableValues[2].totalno
        this.tableValues[2].feedbackavailable = this.tableValues[2].feedbackavailable
        this.tableValues[2].trueCount = this.tableValues[2].trueCount
        this.tableValues[2].falsePositive = this.tableValues[2].falsePositive
        this.tableValues[2].percentageTrue = this.tableValues[2].percentageTrue
        if(this.tableValues[2].percentageFalse > 0) {
          this.tableValues[2].percentageFalse = this.tableValues[2].percentageFalse
        } else {
          this.tableValues[2].percentageFalse = '0'
        }

        this.tableValues[3].totalVerified = this.tableValues[3].totalVerified + this.tableValues[4].totalVerified
        this.tableValues[3].totalno = this.tableValues[3].totalno + this.tableValues[4].totalno
        this.tableValues[3].feedbackavailable = this.tableValues[3].feedbackavailable + this.tableValues[4].feedbackavailable
        this.tableValues[3].trueCount = this.tableValues[3].trueCount + this.tableValues[4].trueCount
        this.tableValues[3].falsePositive = this.tableValues[3].falsePositive + this.tableValues[4].falsePositive    
        if(this.tableValues[3].totalVerified != 0 || this.tableValues[3].trueCount != 0 ) {    
          this.tableValues[3].percentageFalse = ((this.tableValues[3].falsePositive*100)/(this.tableValues[3].totalVerified - this.tableValues[3].trueCount - 0)).toFixed(2)
        } else {
          this.tableValues[3].percentageFalse = '0'
        }


        this.tableValues[4].totalVerified = this.tableValues[5].totalVerified
        this.tableValues[4].totalno = this.tableValues[5].totalno 
        this.tableValues[4].feedbackavailable = this.tableValues[5].feedbackavailable 
        this.tableValues[4].trueCount = this.tableValues[5].trueCount 
        this.tableValues[4].falsePositive = this.tableValues[5].falsePositive 
        if(this.tableValues[4].totalVerified != 0 || this.tableValues[4].trueCount != 0 ) {    
          this.tableValues[4].percentageFalse = ((this.tableValues[4].falsePositive*100)/(this.tableValues[4].totalVerified - this.tableValues[4].trueCount - 0)).toFixed(2)
        } else {
          this.tableValues[4].percentageFalse = '0'
        }

        this.tableValues[5].totalVerified = this.tableValues[6].totalVerified
        this.tableValues[5].totalno = this.tableValues[6].totalno 
        this.tableValues[5].feedbackavailable = this.tableValues[6].feedbackavailable 
        this.tableValues[5].trueCount = this.tableValues[6].trueCount 
        this.tableValues[5].falsePositive = this.tableValues[6].falsePositive 
        if(this.tableValues[5].totalVerified != 0 || this.tableValues[5].trueCount != 0 ) {    
          this.tableValues[5].percentageFalse = ((this.tableValues[5].falsePositive*100)/(this.tableValues[5].totalVerified - this.tableValues[5].trueCount - 0)).toFixed(2)
        } else {
          this.tableValues[5].percentageFalse = '0'
        }

        this.tableValues[6].totalVerified = this.tableValues[7].totalVerified
        this.tableValues[6].totalno = this.tableValues[7].totalno
        this.tableValues[6].feedbackavailable = this.tableValues[7].feedbackavailable
        this.tableValues[6].trueCount = this.tableValues[7].trueCount
        this.tableValues[6].falsePositive = this.tableValues[7].falsePositive
        this.tableValues[6].percentageTrue = this.tableValues[7].percentageTrue
        if(this.tableValues[7].percentageFalse > 0) {
          this.tableValues[6].percentageFalse = this.tableValues[7].percentageFalse
        } else {
          this.tableValues[6].percentageFalse = '0'
        }

        this.tableValues[7].totalVerified = this.tableValues[8].totalVerified
        this.tableValues[7].totalno = this.tableValues[8].totalno
        this.tableValues[7].feedbackavailable = this.tableValues[8].feedbackavailable
        this.tableValues[7].trueCount = this.tableValues[8].trueCount
        this.tableValues[7].falsePositive = this.tableValues[8].falsePositive
        this.tableValues[7].percentageTrue = this.tableValues[8].percentageTrue
        if(this.tableValues[8].percentageFalse > 0) {
          this.tableValues[7].percentageFalse = this.tableValues[8].percentageFalse
        } else {
          this.tableValues[7].percentageFalse = '0'
        }

        this.tableValues[8].totalVerified = this.tableValues[9].totalVerified
        this.tableValues[8].totalno = this.tableValues[9].totalno
        this.tableValues[8].feedbackavailable = this.tableValues[9].feedbackavailable
        this.tableValues[8].trueCount = this.tableValues[9].trueCount
        this.tableValues[8].falsePositive = this.tableValues[9].falsePositive
        this.tableValues[8].percentageTrue = this.tableValues[9].percentageTrue
        if(this.tableValues[9].percentageFalse > 0) {
          this.tableValues[8].percentageFalse = this.tableValues[9].percentageFalse
        } else {
          this.tableValues[8].percentageFalse = '0'
        }

        delete this.tableValues[9]

        //summary row
        for (let cnt in this.tableValues) {
          this.tableValues[0].totalVerified += this.tableValues[cnt].totalVerified
          this.tableValues[0].feedbackavailable += parseInt(this.tableValues[cnt].feedbackavailable)
          this.tableValues[0].trueCount += parseInt(this.tableValues[cnt].trueCount)
          this.tableValues[0].falsePositive += parseInt(this.tableValues[cnt].falsePositive)
          
        }
        // this.tableValues[0].totalVerified -= (this.tableValues[2].totalVerified + this.tableValues[4].totalVerified )
        if(this.tableValues[0].totalVerified != 0 || this.tableValues[0].trueCount != 0 ) {
          this.tableValues[0].percentageFalse = ((this.tableValues[0].falsePositive*100) / (this.tableValues[0].totalVerified - this.tableValues[0].trueCount - 0)).toFixed(2)
        } else {
          this.tableValues[0].percentageFalse = '0'
        }

      
        //For downloading summary table in Excel sheet
      this.exelArr.push(this.tableValues);

      console.log('exelArr', this.exelArr);
      })
      
    },

    cancelAutoUpdate() {
      clearInterval(this.timer);
      clearInterval(this.resTimer);
    },

    defectTypeColor(item) {
      let defType = item['details'];

      if(defType === 'Hanging Part (side view)') {
          return 'red lighten-2'
        } else if(defType === 'Missing Spring(s)') {
          return 'blue lighten-3'
        } else if(defType === 'Broken Spring(s)') {
          return 'lime lighten-2'
        } else if(defType === 'Hanging Part - Undercarriage') {
          return 'green lighten-3'
        } else if(defType === 'EM Pad') {
          return 'amber lighten-2'
        } else if(defType === 'Wagon Door') {
          return 'brown lighten-3'
        } else if(defType === 'End cap screw(s)') {
          return 'cyan lighten-3'
        } else if(defType === 'Axle box cover') {
          return 'blue-grey lighten-2'
        } else if(defType === 'Yoke pin support plate bolts') {
          return 'teal lighten-4'
        } else {
          return ''
        }
    },

    rowClick(row) {
      this.selectedRow = row;
      //   clear the dfis before updating to the next
      this.dfis = '';
    },

    addDfisTrainId() {
      Api().post('api/dfisdata', {
        trainId: this.selectedRow.train_id,
        dfisId: this.dfis
      })
        .then((response) => {
          //   autoupdate in the page once the number is updated
          Api().post('api/dfisdata', {
          })
            .then((response) => {
              this.dashboardFullDay = response.data;

              const splitKeyValue = obj => {
                const keys = Object.keys(obj);
                const res = [];
                for (let i = 0; i < keys.length; i++) {
                  res.push({
                    'train_id': obj[keys[i]]["train_id"],
                    'dfis_train_id': obj[keys[i]]["dfis_train_id"]
                  });
                };
                return res;
              };

              this.day_info = splitKeyValue(this.dashboardFullDay);

            })
            .catch(function (error) {
              ApiResponse.checkErrorCode(error.response.status);
            });
          this.dialogDfis = false;
        })
        .catch(function (error) {
          ApiResponse.checkErrorCode(error.response.status);
        });
    },

    convertTime(dateWithT) {
      var d = new Date(dateWithT);

      return (this.convertTimestamp(d.getTime() / 1000));

    },
    getStartDate(){
      var startDate1 = new Date(new Date().getFullYear(),0,1);
      var startYear = startDate1.getFullYear();
      var startMonth = String(startDate1.getMonth()+1).padStart(2,'0');
      var startDay = String(startDate1.getDate()).padStart(2,'0');
      return (`${startDay}-${startMonth}-${startYear}`)
    },

    getStartEndDate(){
      var startDate1 = new Date(new Date().getFullYear(),0,1);
      var startYear = startDate1.getFullYear();
      var startMonth = String(startDate1.getMonth()+1).padStart(2,'0');
      var startDay = String(startDate1.getDate()).padStart(2,'0');
      var startHours = String(startDate1.getHours()).padStart(2, '0');
      var startMinutes = String(startDate1.getMinutes()).padStart(2, '0');
      var startSeconds = String(startDate1.getSeconds()).padStart(2, '0');
      var endDate1 = new Date();
      endDate1.setHours(23, 59, 59);
      var endYear = endDate1.getFullYear();
      var endMonth = String(endDate1.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
      var endDay = String(endDate1.getDate()).padStart(2, '0');
      var endHours = String(endDate1.getHours()).padStart(2, '0');
      var endMinutes = String(endDate1.getMinutes()).padStart(2, '0');
      var endSeconds = String(endDate1.getSeconds()).padStart(2, '0');
      var startDateString = `${startDay}-${startMonth}-${startYear} ${startHours}:${startMinutes}:${startSeconds}`; 
      var endDateString = `${endDay}-${endMonth}-${endYear} ${endHours}:${endMinutes}:${endSeconds}`;
      return {
        date1: startDateString,
        date2: endDateString
    };

    },

    getCurrentDateIST() {
      var dateUTC = (new Date());
      var dateUTC = dateUTC.getTime();
      var dateIST = new Date(dateUTC);

      dateIST.setHours(dateIST.getHours() + 5);
      dateIST.setMinutes(dateIST.getMinutes() + 30);

      return (new Date(dateIST).toISOString().substr(0, 10));
    },

    getDateDisplay() {
      const d = new Date();
      const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
      const mo = new Intl.DateTimeFormat('en', { month: 'long' }).format(d);
      const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
      const hr = new Intl.DateTimeFormat('en', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
      }).format(d);

      return (`${da} ${mo} ${ye} ${hr}`);
    },

    disableFutureDates(datenoTime) {
      
      let monthVal = 0;
      let dateVal = 0;      
      if(datenoTime.getDate() < 10) {
        dateVal = "0" + datenoTime.getDate();
      } else {
        dateVal = parseInt(datenoTime.getDate());
      }

      if(datenoTime.getMonth() < 10) {
        monthVal = "0" + (datenoTime.getMonth() + 1);
      } else {
        monthVal = parseInt(datenoTime.getMonth() + 1);
      }
      let dateRecvd = datenoTime.getFullYear() + "-" + monthVal + "-" + dateVal; 
      return dateRecvd
    },

    convertTimestamp(timestamp) {
      var d = new Date(timestamp * 1000),	// Convert the passed timestamp to milliseconds
        yyyy = d.getFullYear(),
        mm = ('0' + (d.getMonth() + 1)).slice(-2),	// Months are zero based. Add leading 0.
        dd = ('0' + d.getDate()).slice(-2),			// Add leading 0.
        hh = d.getHours(),
        h = hh,
        min = ('0' + d.getMinutes()).slice(-2),		// Add leading 0.
        sec = ('0' + d.getSeconds()).slice(-2),
        ampm = 'AM',
        time;

      if (hh > 12) {
        h = hh - 12;
        ampm = 'PM';
      } else if (hh === 12) {
        h = 12;
        ampm = 'PM';
      } else if (hh == 0) {
        h = 12;
      }

      // ie: 2013-02-18 8:35 AM
      time = dd + '-' + mm + '-' + yyyy + ' ' + h + ':' + min + ':' + sec + ' ' + ampm

      return time;
    },

    convertTimestamp24Hr(timestamp) {
      var d = new Date(timestamp * 1000),	// Convert the passed timestamp to milliseconds
        yyyy = d.getFullYear(),
        mm = ('0' + (d.getMonth() + 1)).slice(-2),	// Months are zero based. Add leading 0.
        dd = ('0' + d.getDate()).slice(-2),			// Add leading 0.
        hh = d.getHours(),
        h = hh,
        min = ('0' + d.getMinutes()).slice(-2),		// Add leading 0.
        sec = ('0' + d.getSeconds()).slice(-2),
        ampm = 'AM',
        time;

      // ie: 2013-02-18 8:35 AM
      time = yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + min + ':' + sec; // + ' ' + ampm

      return time;
    },

    timeDifference(date1, date2) {
      var d1 = new Date(0);
      var d2 = new Date(0);
      var d3 = new Date(0);
      d1.setUTCSeconds(date1);
      d2.setUTCSeconds(date2);

      var diffSec_temp, diffMin_temp, hr_temp;
      var diffHr = 0, diffMin, diffSec;

      diffSec_temp = (d1.getTime() - d2.getTime()) / 1000;

      if ((diffSec_temp / 60) > 60) {
        diffMin_temp = parseInt(diffSec_temp / 60);
        hr_temp = 1;
        while ((hr_temp * 60) < diffMin_temp) {
          hr_temp++;
        }
        diffHr = hr_temp - 1; //to get the prev hour value
        diffMin = diffMin_temp - (diffHr * 60); //to get the minute value
        diffSec = parseInt(((diffSec_temp / 60) % 1) * 60); //to get the seconds value
      }
      else {

        diffMin = parseInt(diffSec_temp / 60); //to get minutes (quotient only)
        diffSec = diffSec_temp - (diffMin * 60);

      }

      return diffHr + ' ' + 'hours' + ' ' + diffMin + ' ' + 'minutes' + ' ' + diffSec + ' ' + 'seconds';

    },
    sendToPlay(trainId) {

      this.trainDetailed = [];
      this.consol_trainconsolidated1 = [];
      this.consol_trainconsolidated2 = [];
      this.consol_traindetailed = [];
      this.entry_train_detailed = [];
      this.fwild_defects = [];
      this.mvis_defects = [];

      Api().post('/api/train_detailed', {
        train_date: this.date2,
        trainId: trainId,
      })
        .then((response) => {
          this.trainDetailed = response.data;
          this.entry_train_detailed = this.trainDetailed.final_result;

          for (let i in this.entry_train_detailed.consolidated_result) {
            this.consol_trainconsolidated1.push({
              'train_id': this.entry_train_detailed.consolidated_result[i][0],
              'dfis': this.entry_train_detailed.consolidated_result[i][1],
              'entry_time': this.entry_train_detailed.consolidated_result[i][3],
              'axles': this.entry_train_detailed.consolidated_result[i][6],
            })
          }

          for (let i in this.entry_train_detailed.consolidated_result) {
            this.consol_trainconsolidated2.push({
              'direction': this.entry_train_detailed.consolidated_result[i][2],
              'train_speed': this.entry_train_detailed.consolidated_result[i][5],
              'maint_wheels': this.entry_train_detailed.consolidated_result[i][7],
              'critical_wheels': this.entry_train_detailed.consolidated_result[i][8],
            })
          }

          for (let i in this.entry_train_detailed.detail_result) {
            this.consol_traindetailed.push({
              'axle_id': this.entry_train_detailed.detail_result[i][0],
              'rake_id': this.entry_train_detailed.detail_result[i][1],
              'axle_speed': this.entry_train_detailed.detail_result[i][2],
              'avg_dyn_load_left': this.entry_train_detailed.detail_result[i][3],
              'max_dyn_load_left': this.entry_train_detailed.detail_result[i][4],
              'ilf_left': this.entry_train_detailed.detail_result[i][5],
              'wheel_status_left': this.entry_train_detailed.detail_result[i][6],
              'avg_dyn_load_right': this.entry_train_detailed.detail_result[i][7],
              'max_dyn_load_right': this.entry_train_detailed.detail_result[i][8],
              'ilf_right': this.entry_train_detailed.detail_result[i][9],
              'wheel_status_right': this.entry_train_detailed.detail_result[i][10],
            })
          }

          for (let i in this.entry_train_detailed.defect_result) {
            this.fwild_defects.push({
              'axle_id': this.entry_train_detailed.defect_result[i][0],
              'axle_timestamp': this.entry_train_detailed.defect_result[i][1],
              'rake_id': this.entry_train_detailed.defect_result[i][2],
              'axle_speed': this.entry_train_detailed.defect_result[i][3],
              'max_dyn_load_left': this.entry_train_detailed.defect_result[i][4],
              'max_dyn_load_right': this.entry_train_detailed.defect_result[i][5],
              'ilf_left': this.entry_train_detailed.defect_result[i][6],
              'ilf_right': this.entry_train_detailed.defect_result[i][7],
              'wheel_status_left': this.entry_train_detailed.defect_result[i][8],
              'wheel_status_right': this.entry_train_detailed.defect_result[i][9],
              'side': this.getSide(this.entry_train_detailed.defect_result[i][8], this.entry_train_detailed.defect_result[i][9]),
              'action_taken': null,
            })
          }

          for (let i in this.entry_train_detailed.mvis_defect_result) {
            this.mvis_defects.push({
              'tagged_wagon_id': this.entry_train_detailed.mvis_defect_result[i][0],
              'tagged_bogie_id': this.entry_train_detailed.mvis_defect_result[i][1],
              'side': this.entry_train_detailed.mvis_defect_result[i][2],
              'wagon_id': this.entry_train_detailed.mvis_defect_result[i][3],
              'wagon_type': this.entry_train_detailed.mvis_defect_result[i][4],
              'defect_image': globalConf.djangoBackend + '/media/images/' + this.entry_train_detailed.mvis_defect_result[i][5],
              'defect_desc': this.entry_train_detailed.mvis_defect_result[i][6],
              'action_taken': this.entry_train_detailed.mvis_defect_result[i][7],
            })
          }

          this.$router.push({ name: 'Train Detail Report', params: { train_id: trainId, train_info1: this.consol_trainconsolidated1, train_info2: this.consol_trainconsolidated2, all_wheel_info: this.consol_traindetailed, fwild_defects: this.fwild_defects, mvis_defects: this.mvis_defects } })
        })
        .catch(function (error) {
          ApiResponse.checkErrorCode(error.response.status);
        });
    },

    getSide(leftWheel, rightWheel) {
      if (leftWheel >= 2) {
        this.infoSide = "Left"
      }
      else if (rightWheel >= 2) {
        this.infoSide = "Right"
      }
      return (this.infoSide);
    },

    avg_time(ts1, ts2) {

      var timeIndx = 0;
      var timeChk = [];
      var avgSec = 0;
      var avgTime = '';

      while ((timeIndx < ts1.length) && (timeIndx < ts2.length)) {
        timeChk[timeIndx] = this.timeDifference(ts2[timeIndx], ts1[timeIndx]);
        timeIndx++;
      }

      avgSec = this.getAverageTime(timeChk)
      avgTime = this.sec2time(avgSec);

      if (timeIndx != 0) {
        return avgTime;
      }
      else {
        this.day_train_count = null;
        this.day_unloaded = null;
        return null;
      }
    },
    getAverageTime(timeChk) {
      var timeSlice = [];
      var timeIndxLoc = 0;
      var secondsSum = 0;
      var avgSec = 0;

      while (timeIndxLoc < timeChk.length) {
        timeSlice = timeChk[timeIndxLoc].split(' '); // split it at the colons
        secondsSum = secondsSum + (+timeSlice[0]) * 60 * 60 + (+timeSlice[2]) * 60 + (+timeSlice[4]);
        timeIndxLoc = timeIndxLoc + 1;
      }
      avgSec = secondsSum / timeChk.length;

      return avgSec;
    },
    sec2time(timeInSeconds) {
      var pad = function (num, size) { return ('000' + num).slice(size * -1); },
        time = parseFloat(timeInSeconds).toFixed(3),
        hours = Math.floor(time / 60 / 60),
        minutes = Math.floor(time / 60) % 60,
        seconds = Math.floor(time - minutes * 60),
        milliseconds = time.slice(-3);

      return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2);
    },

    // longer waiting time of torpedo
    longer_time(ts1, ts2) {

      var timeIndx = 0;
      var timeChk = [];
      var secMax = 0;
      var secMaxAvg = 0;
      var longTime = '';

      while ((timeIndx < ts1.length) && (timeIndx < ts2.length)) {
        timeChk[timeIndx] = this.timeDifference(ts2[timeIndx], ts1[timeIndx]);
        timeIndx++;
      }

      secMax = this.getLongAverageTime(timeChk);
      longTime = this.sec2time(secMax);

      if (timeIndx != 0) {
        return longTime;
      }
      else {
        this.day_train_count = null;
        this.day_unloaded = null;
        return null;
      }
    },

    getLongAverageTime(timeChk) {
      var timeSlice = [];
      var timeIndxLoc = 0;
      var secondsSum = 0;
      var avgSec = 0;

      while (timeIndxLoc < timeChk.length) {
        timeSlice = timeChk[timeIndxLoc].split(' '); // split it at the colons
        secondsSum = secondsSum + (+timeSlice[0]) * 60 * 60 + (+timeSlice[2]) * 60 + (+timeSlice[4]);
        timeIndxLoc = timeIndxLoc + 1;
      }
      avgSec = secondsSum / timeChk.length;

      return avgSec;
    },

    sec2time(timeInSeconds) {
      var pad = function (num, size) { return ('000' + num).slice(size * -1); },
        time = parseFloat(timeInSeconds).toFixed(3),
        hours = Math.floor(time / 60 / 60),
        minutes = Math.floor(time / 60) % 60,
        seconds = Math.floor(time - minutes * 60),
        milliseconds = time.slice(-3);

      return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2);
    },

    plotPieChart(weekPoint_cntArrPie, pointIdArrPie) {

      return {
        series: weekPoint_cntArrPie,
        chartOptions: {
          chart: {
            foreColor: 'text--primary'
          },
          labels: pointIdArrPie,
          dataLabels: {
            enabled: false
          },
          legend: {
            show: true,
            position: 'bottom'
          },
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
              },
            },
          }]
        }
      }
    },
    plotPieHABDChart(arr) {
    console.log(arr)
      return {
        seriesPie: arr,
          chartOptions: {
            chart: {
              width: 480,
              type: 'pie',
            },
            labels: ['Defective EMs Pad', 'Open Wagon Door', 'Hanging Part (Side View)', 'Missing Spring(s)', 'Missing end cap screw(s)','Broken Spring(s)','Missing axle box cover','Missing yoke pin support plate bolts','Hanging part - Undercarriage'],
            dataLabels: {
              formatter: function (val, opts) {
                console.log(opts.w.config.series)
                console.log(opts.w.config.series[opts.seriesIndex])
                  return opts.w.config.series[opts.seriesIndex]
              },
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 400
                },
                legend: {
                  position: 'bottom'
                }
              }
            }],
          },
      }
    },


    // bar chart
    plotBarChart(ps1Arr, ps2Arr, dateArray) {
      console.log(ps1Arr);
      console.log(ps2Arr);
      console.log(ps1Arr);
      let currentMonth = new Date().toLocaleString('default', { month: 'short' });
  
  if (dateArray[0] === currentMonth) {
    dateArray[0] += ' (Curr. Month)';
  }
      let themeState = window.localStorage.getItem("themeData") //true for dark theme

      return {
        series: [{
          name: 'Total Alerts',
          data: ps1Arr,
          
        },
        {
          name: 'True Alerts',
          data: ps2Arr,
        },
        ],
        chartOptions: {
          chart: {
            foreColor: 'text--primary',
            toolbar: {
              show: false,
            },
          },
          legend: {
            show: true,
            position: 'bottom'
          },
          grid: {
            show: false,
          },
          labels: dateArray,
          plotOptions: {
            bar: {
              horizontal: false,
              dataLabels: {
                position: 'top',
                colors: ['#666']
              },
            }
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '12px',
              colors: ['#666']
            },
            offsetY: -15,
          },
          stroke: {
            show: true,
            width: 1,
            colors: ['#fff']
          },
          tooltip: {
            shared: true,
            intersect: false,
            followCursor: true,
            
          },
          
          yaxis: {
            labels: {
              formatter: function (val) {
                if (val != null) {
                  return val.toFixed(0)
                }
              },
              style: {
                fontSize: '12px',
                colors: 'grey'
              }
            },
          },
          xaxis: {
            labels: {
              rotate: -90,
              style: {
                fontSize: '12px',
                colors: 'grey'
              }
            },
          },
        },
      }
    },
    
//  plotBarChart(ps1Arr, ps2Arr, dateArray) {
//   let themeState = window.localStorage.getItem("themeData"); // true for dark theme

//   // Get the current month in the 'Mon' format (e.g., 'May')
//   const currentMonth = new Date().toLocaleString('default', { month: 'short' });

//   // Function to determine color based on the month
//   function getBarColor(month, defaultColor, currentMonthColor) {
//     return month === currentMonth ? currentMonthColor : defaultColor;
//   }

//   return {
//     series: [
//       {
//         name: 'Total Alerts',
//         data: ps1Arr,
//       },
//       {
//         name: 'True Alerts',
//         data: ps2Arr,
//       }
//     ],
//     chartOptions: {
//       chart: {
//         foreColor: 'text--primary',
//         toolbar: {
//           show: false,
//         },
//       },
//       legend: {
//         show: true,
//         position: 'bottom',
//         labels: {
//           colors: ['#008FFB', '#00E396'], // Blue for Total Alerts, Green for True Alerts
//         },
//       },
//       grid: {
//         show: false,
//       },
//       labels: dateArray,
//       plotOptions: {
//         bar: {
//           horizontal: false,
//           dataLabels: {
//             position: 'top',
//             colors: ['#666'],
//           },
//           colors: {
//             ranges: dateArray.map((month, index) => ({
//               from: index,
//               to: index,
//               color: getBarColor(month, '#008FFB', '#0072c8'), // Blue for previous months, Red(0072c8) for current month (Total Alerts)
//             })),
//           },
//         },
//       },
//       dataLabels: {
//         enabled: true,
//         style: {
//           fontSize: '12px',
//           colors: ['#666'],
//         },
//       },
//       stroke: {
//         show: true,
//         width: 1,
//         colors: ['#fff'],
//       },
//       tooltip: {
//         shared: true,
//         intersect: false,
//         followCursor: true,
//       },
//       yaxis: {
//         labels: {
//           formatter: function (val) {
//             if (val != null) {
//               return val.toFixed(0);
//             }
//           },
//           style: {
//             fontSize: '12px',
//             colors: 'grey',
//           },
//         },
//       },
//       xaxis: {
//         labels: {
//           rotate: -90,
//           style: {
//             fontSize: '12px',
//             colors: 'grey',
//           },
//         },
//       },
      
//       colors: [
//         function ({ value, dataPointIndex }) {
//           // This function applies color to Total Alerts
//           const month = dateArray[dataPointIndex];
//           return getBarColor(month, '#008FFB', '#0072c8'); // Blue for previous months, Red for current month (Total Alerts)
//         },
//         function ({ value, dataPointIndex }) {
//           // This function applies color to True Alerts
//           const month = dateArray[dataPointIndex];
//           return getBarColor(month, '#00E396', '#00b074'); // Green for previous months, Yellow for current month (True Alerts)
//         },
//       ],
//     },
//   };
// },



    plotBarChart1(ps1Arr, ps2Arr, dateArray) {
      let themeState = window.localStorage.getItem("themeData") //true for dark theme

      return {
        series: [{
          name: 'Total Alerts',
          data: ps1Arr,
        },
        {
          name: 'True Alerts',
          data: ps2Arr,
        },
        ],
        chartOptions: {
          chart: {
            foreColor: 'text--primary',
            toolbar: {
              show: false,
            },
          },
          legend: {
            show: true,
            position: 'bottom'
          },
          grid: {
            show: false,
          },
          labels: dateArray,
          plotOptions: {
            bar: {
              horizontal: false,
              dataLabels: {
                position: 'top',
                colors: ['#666']
              },
            }
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '12px',
              colors: ['#666']
            }
          },
          stroke: {
            show: true,
            width: 1,
            colors: ['#fff']
          },
          tooltip: {
            shared: true,
            intersect: false,
            followCursor: true,
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                if (val != null) {
                  return val.toFixed(0)
                }
              },
              style: {
                fontSize: '12px',
                colors: 'grey'
              }
            },
          },
          xaxis: {
            labels: {
              rotate: -90,
              style: {
                fontSize: '12px',
                colors: 'grey'
              }
            },
          },
        },
      }
    },

    plotDefectwiseBarChart(seriesArr, seriesTrue, dateArray) {
      let themeState = window.localStorage.getItem("themeData") //true for dark theme
      console.log('seriesArr', seriesArr);

      return {
        series: [{
          name: 'Percentage (True)',
          data: seriesTrue,
        },
        {          
          name: 'Percentage (False)',
          data: seriesArr,
        },
        ],
        chartOptions: {
          chart: {
            foreColor: 'text--primary',
            toolbar: {
              show: false,
            },
          },
          legend: {
            show: true,
            position: 'bottom'
          },
          grid: {
            show: false,
          },
          plotOptions: {
            bar: {
              horizontal: false,              
              dataLabels: {
                position: 'top',
                colors: ['#666']
              },              
            }
          },
          colors: [ // this array contains different color code for each bar data
              "rgb(0, 227, 150)",
              "rgb(255, 109, 96)",              
          ],
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '12px',
              colors: ['#666']
            }
          },
          stroke: {
            show: true,
            width: 1,
            colors: ['#fff']
          },
          tooltip: {
            shared: true,
            intersect: false,
            followCursor: true,
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                if (val != null) {
                  return val.toFixed(2)
                }
              },
              style: {
                fontSize: '12px',
                colors: 'grey'
              }
            },
          },         
          xaxis: {
            categories: [           
            ['Hanging', 'Part', '(side view)'], 
            ['Hanging part -', 'Undercarriage'],
            ['Missing', 'Spring(s)'], 
            ['Broken', 'Spring(s)'],
            ['Missing', 'axle box', 'cover'],
            ['Missing', 'end cap', 'screw(s)'],            
            ['Missing', 'yoke pin', 'support', 'plate bolts'],            
            ['Defective', 'EM Pads'], 
            ['Open', 'Wagon', 'Door'], 
            ],
            labels: {
              rotate: 0,
              style: {
                fontSize: '12px',
                colors: 'grey'
              }
            },
          },          
        },
      }
    },

    plotTotalTFBarChart(totalTrue, totalFalse, dateArray) {
      let themeState = window.localStorage.getItem("themeData") //true for dark theme
      console.log('seriesTotalTrue', totalTrue, totalFalse);

      return {
        series: [{
          name: 'Total Percentage (True Defect)',
          data: totalTrue,
        },
        {          
          name: 'Total Percentage (False Positive)',
          data: totalFalse,
        },
        ],
        chartOptions: {
          chart: {
            foreColor: 'text--primary',
            toolbar: {
              show: false,
            },
          },
          legend: {
            show: true,
            position: 'bottom'
          },
          grid: {
            show: false,
          },  
          labels: ['Total Percentage'], //, 'Total False Positive Percentage'],        
          plotOptions: {
            bar: {
              horizontal: false,              
              dataLabels: {
                position: 'top',
                colors: ['#666']
              },              
            }
          },
          colors: [ // this array contains different color code for each bar data
              "rgb(0, 227, 150)",
              "rgb(255, 109, 96)",              
          ],
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '12px',
              colors: ['#666']
            }
          },
          stroke: {
            show: true,
            width: 1,
            colors: ['#fff']
          },
          tooltip: {
            shared: true,
            intersect: false,
            followCursor: true,
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                if (val != null) {
                  return val.toFixed(2)
                }
              },
              style: {
                fontSize: '12px',
                colors: 'grey'
              }
            },
          },         
          xaxis: {            
            labels: {              
              style: {
                fontSize: '12px',
                colors: 'grey'
              }
            },
          },          
        },
      }
    },

    handleDownload() {

      this.downloadLoading = true
      import('@/assets/vendors/Export2Exel').then(excel => {

        const tHeader = ['Sl. No.', 'Total Units (Verified)', 'Details', 'Total Alerts', 'Feedback Given', 'True Alerts', 'False Alerts', 'False Alerts (%)']
        const filterVal = ['sno', 'totalVerified', 'details', 'totalno', 'feedbackavailable', 'trueCount', 'falsePositive', 'percentageFalse']
        const list = this.exelArr
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename:'The_MVIS_summary_table_from_'+this.startdateFormatted +"_to_"+this.enddateFormatted,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })

    },

    formatJson(filterVal, jsonData) {

      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
      },

      addRemarksTrainId(row) {
        console.log('testing', this.remarks);
        this.selectedRow = row;
        let img_name = this.selectedRow.defect_image.split('/')[5];
        Api().post('api/remarksData', {
          train_id: this.selectedRow.train_id,
          remarks: this.remarks,
          defect_img: img_name
        })
        .then((response) => {
            console.log("Saved to DB!");
            console.log('remarks-resp', response.data);
            
            // console.log(response.data);
            //   autoupdate in the page once the number is updated
            // let len=this.consol_trainconsolidated1.length;
            // for(let i=0;i<len;i++){
            //   if(this.selectedRow.train_id==this.consol_trainconsolidated1[i]['train_id']){
            //     this.consol_trainconsolidated1[i]['dfis']=this.dfis;
            //   }
            // };

            // Api().post('api/remarksData', {
            //   })
            //   .then((response) => {
            //        console.log(response.data);
            //     // this.dashboardFullDay = response.data;

            //         const splitKeyValue = obj => {
            //             const keys = Object.keys(obj);
            //             const res = [];
            //             for(let i = 0; i < keys.length; i++){
            //                 res.push({
            //                     'train_id': obj[keys[i]]["train_id"],
            //                     'dfis_train_id': obj[keys[i]]["dfis_train_id"]
            //                 });
            //             };
            //             return res;
            //             };

            //         // this.day_info = splitKeyValue(this.dashboardFullDay);

            //     })
                // .catch(function (error) {
                //     // console.log(error);
                //     ApiResponse.checkErrorCode(error.response.status);
                // });
                // this.dialogRemarks = false;
                // this.dashboardFn()

                // this.snackbar = true;
        })
        .catch(function (error) {
            ApiResponse.checkErrorCode(error.response.status);
        });
        this.dashboardFn();
    },

    

    async trueCountDetails(item) {     
// console.log('start-end-date', this.startdateFormatted, this.enddateFormatted, item['details']);
this.mvis_defectwise_arr = [];
this.mvis_summary_arr = [];
let defType = item['details'];
 if(defType == 'Axle box cover & End cap screw(s)') {
   var defCode1 = '007';
   var defCode2 = '005';
 } else if(defType == 'Spring Assembly') {
   var defCode1 = '004';
   var defCode2 = '006';
 } else if(defType == 'Summary') {
   var defCode1 = '%';
   var defCode2 = '';
 } else {
   var defCode1 = this.mvis_defect_code_num[defType];
   var defCode2 = '';
 }

//var defCode = this.mvis_defect_code_num[defType];
console.log('def_code', item['details'], this.startDATE, this.endDATE, defCode1,defCode2);
console.log("showcharts:", this.showscharts)
if(this.showscharts == false){
  this.startDATE = this.defaultStartDate;
  this.endDATE = this.defaultEndDate
}else{
  this.startDATE = this.startDATE;
  this.endDATE = this.endDATE 
}
if(defCode1 != undefined|| defCode2 != undefined) {        
  //this.show_mvis_summary = true;
  await Api().post('/api/trueCountDetails', {
    start: this.startDATE,
    end: this.endDATE,
    defCode1: defCode1,
    defCode2: defCode2,
    
    
  }).then(async response2 => {
    let mvis_summary_table_result = [];
    console.log('response2', response2.data);
    let defectWiseTrueDetails = response2.data;
    mvis_summary_table_result = defectWiseTrueDetails.mvis_truecount_result;
    console.log('res', mvis_summary_table_result);

    for ( let i in mvis_summary_table_result ) {
      this.mvis_summary_arr.push({
      'train_id': mvis_summary_table_result[i][1],
      'tagged_wagon_id': mvis_summary_table_result[i][2],
      'tagged_bogie_id': mvis_summary_table_result[i][3], //WAGON NUMBER ADDED
      'side': mvis_summary_table_result[i][4],
      'defect_image': globalConf.djangoBackend + '/media/images/' + mvis_summary_table_result[i][7],
      'defect_desc': mvis_summary_table_result[i][8],
      'action_taken': mvis_summary_table_result[i][9],            
    })
    }

  })


} else if(defType === 'Summary') {
  console.log(defType);
  //this.show_mvis_summary = true;
  
  await Api().post('/api/trueCountDetails', {
    start: this.startDATE,
    end: this.endDATE,
    defCode1:defCode1,
  
    
  }).then(async response3 => {
    console.log('response3', response3.data);
    let mvis_summary_table_result = [];
    let defectWiseTrueDetails = response3.data;
    mvis_summary_table_result = defectWiseTrueDetails.mvis_truecount_result;
    console.log('res', mvis_summary_table_result);

    for ( let i in mvis_summary_table_result ) {
      this.mvis_summary_arr.push({
      'train_id': mvis_summary_table_result[i][1],
      'tagged_wagon_id': mvis_summary_table_result[i][2],
      'tagged_bogie_id': mvis_summary_table_result[i][3], //WAGON NUMBER ADDED
      'side': mvis_summary_table_result[i][4],
      'defect_image': globalConf.djangoBackend + '/media/images/' + mvis_summary_table_result[i][7],
      'defect_desc': mvis_summary_table_result[i][8],
      'action_taken': mvis_summary_table_result[i][9],            
    })
    }
  })
} else {
  //this.show_mvis_summary = false;
  console.log('improper defect code');
}
this.show_mvis_summary = true;
this.show_mvis_false_summary = false;


},

async falseCountDetails(item) {

this.mvis_defectwise_arr = [];
this.mvis_false_summary_arr = [];
let defType = item['details'];
if(defType == 'Axle box cover & End cap screw(s)') {
   var defCode1 = '007';
   var defCode2 = '005';
 } else if(defType == 'Spring Assembly') {
   var defCode1 = '004';
   var defCode2 = '006';
 } else if(defType == 'Summary') {
   var defCode1 = '%';
   var defCode2 = '';
 }else {
   var defCode1 = this.mvis_defect_code_num[defType];
   var defCode2 = '';
 }
//let defCode = this.mvis_defect_code_num[defType];
console.log('def_code', item['details'], this.startDATE, this.endDATE, this.mvis_defect_code_num[defType]);
if(this.showscharts == false){
  this.startDATE = this.defaultStartDate;
  this.endDATE = this.defaultEndDate
}else{
  this.startDATE = this.startDATE;
  this.endDATE = this.endDATE 
}

if(defCode1!= undefined || defcod2!= undefined) {        
  //this.show_mvis_false_summary = true;
  await Api().post('/api/falseCountDetails', {
    start: this.startDATE,
    end: this.endDATE,
    defCode1: defCode1,
    defCode2:defCode2,
  }).then(async response2 => {
    let mvis_summary_table_result = [];
    console.log('response2', response2.data);
    let defectWiseFalseDetails = response2.data;
    mvis_summary_table_result = defectWiseFalseDetails.mvis_falsecount_result;
    console.log('res', mvis_summary_table_result);

    for ( let i in mvis_summary_table_result ) {
      this.mvis_false_summary_arr.push({
      'train_id': mvis_summary_table_result[i][1],
      'tagged_wagon_id': mvis_summary_table_result[i][2],
      'tagged_bogie_id': mvis_summary_table_result[i][3], //WAGON NUMBER ADDED
      'side': mvis_summary_table_result[i][4],
      'defect_image': globalConf.djangoBackend + '/media/images/' + mvis_summary_table_result[i][7],
      'defect_desc': mvis_summary_table_result[i][8],
      'action_taken': mvis_summary_table_result[i][9],            
    })
    }

  })
} else if(defType === 'Summary') {
  console.log(defType);
  //this.show_mvis_false_summary = true;
  await Api().post('/api/falseCountDetails', {
    start: this.startDATE,
    end: this.endDATE,
    defCode1:defCode1,
    
  }).then(async response3 => {
    console.log('response3', response3.data);
    let mvis_summary_table_result = [];
    let defectWiseFalseDetails = response3.data;
    mvis_summary_table_result = defectWiseFalseDetails.mvis_falsecount_result;
    console.log('res', mvis_summary_table_result);

    for ( let i in mvis_summary_table_result ) {
      this.mvis_false_summary_arr.push({
      'train_id': mvis_summary_table_result[i][1],
      'tagged_wagon_id': mvis_summary_table_result[i][2],
      'tagged_bogie_id': mvis_summary_table_result[i][3], //WAGON NUMBER ADDED
      'side': mvis_summary_table_result[i][4],
      'defect_image': globalConf.djangoBackend + '/media/images/' + mvis_summary_table_result[i][7],
      'defect_desc': mvis_summary_table_result[i][8],
      'action_taken': mvis_summary_table_result[i][9],            
    })
    }
  console.log("MVIS SUMMARYYYYY ", this.mvis_false_summary_arr)
  })
}
else {
  //this.show_mvis_false_summary = false;
  console.log('improper defect code');
}
this.show_mvis_false_summary = true;
this.show_mvis_summary = false;

},

    audioCheck() {
      let a = this.$refs.audioRef;
      if (!a.paused) {
        a.pause();
      }
    },
    formatDate1 (date) {
      this.disabled = false;
      let datenoTime = new Date(date);
      let monthVal = 0;
      let dateVal = 0;      
      if(datenoTime.getDate() < 11) {
        dateVal = "0" + datenoTime.getDate();
      } else {
        dateVal = parseInt(datenoTime.getDate());
      }

      if(datenoTime.getMonth() < 11) {
        monthVal = "0" + (datenoTime.getMonth() + 1);
      } else {
        monthVal = parseInt(datenoTime.getMonth() + 1);
      }
      let dateRecvd = datenoTime.getFullYear() + "-" + monthVal + "-" + dateVal;      
      if (!date) return null
       console.log("date", dateRecvd);     

      //const [year, month, day] = dateRecvd.split('-')
      const [year, month, day] = date.split('-')
       console.log("DMY", day, month, year);     
      return (`${day}-${month}-${year}`)
    },

    formatTime(time){
      const [hours, minutes] = time.split(':');
      const seconds = '00'; // You want to add seconds
      return `${hours}:${minutes}:${seconds}`;
    },
    epochConvert (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      // console.log((new Date(year, month - 1, day)).getTime())
      return ((new Date(year, month - 1, day)).getTime())
    },
   /* parseDate1 (date) {
	var date2 = this.getCurrentDateIST();

      var dateStr = date2.split("-").slice();
      var dateT = dateStr[2]
      var monT1 = dateStr[1]
      var yearT = dateStr[0]
	var mnt = 0;
	var dateVal = 0;
      if (!date) return null
      const [year, month, day] = date.split('-')
	if(month <= 9) {
	mnt = parseInt(month.padStart(2, '0'));
	} else {
	mnt = parseInt(month);
	}
	if(day <= 9) {
	dateVal = parseInt(day.padStart(2, '0'));
	} else {
	dateVal = parseInt(day);
	}
      console.log(`dateVal-mnt-${year}`)
      //return (`${day}-${month}-${year}`)
      return (dateT-monT1-yearT)
    },
    */
    parseDate1 (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
        console.log('date', year, month, day);
      return (`${day}-${month}-${year}`)
    },
    parseTime(time) {
      if (!time) return null;
      const [hour, minute] = time.split(':');
      return `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
    }
  },



  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    this.cancelAutoUpdate();
  }

}

</script>

<style lang="scss">

.defect_heading::before{
  content: '\2022';
  font-size: 2em;
  vertical-align: middle;
}

.button1, .button2 {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 999;
}

.home-button {
  position: fixed;
  bottom: 20px;
  right: 100px;
  background-color: #4caf50;;
  z-index: 999;
  // box-shadow: 0px -4px 3px rgb(27 27 24 /75%);
}

.full-width-table {
  width: 100% !important;
}


.large-button {
  font-size: 22px !important; 
}

.v-sheet {
  border-radius: 4px;
}

.fontChange {
  font-size: 16px !important;

}

.ct-label {
  color: grey;
}

.ct-series-a .ct-bar,
.ct-series-a .ct-point {
  stroke: #00cae3;
}

.ct-series-a .ct-area,
.ct-series-a .ct-slice-donut-solid,
.ct-series-a .ct-slice-pie {
  fill: #61def1;
}

@media only screen and (min-width: 1000px) {
  .charts-section {
    bottom: 0;
    left: 0;
    right: 0;
    max-height: 450px;
    /* max height */
    overflow: hidden;
    /* hide overflow */
    z-index: 100000;
    width: 100%;
  }
}

#chartContainer .apexcharts-tooltip {
  color: #000000;
}

#chartContainer .apexcharts-tooltip .apexcharts-tooltip-series-group.active {
  background: #ffffff !important;
}

.text-fields-row {
  display: flex;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 16px;
}
.custom-pointer{
  cursor: pointer;
}

.custom-button{
  font-size: 20px !important;
  padding: 3px 12px !important;

}

</style>